import commonLogics from '../../../utils/common-logic.service';
import { Component, ElementRef, HostListener, OnInit, OnDestroy, Optional, TemplateRef, ViewChild } from '@angular/core';
import * as Leaflet from 'leaflet';
import { CommonModule } from '@angular/common';
import constant from '../../../app.constant';
import { LocalStorageService } from '../../../utils/local-storage.service';
import { CommonHttpService } from '../../../utils/common-http.service';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { BreadcrumbService } from '../../../shared/services/breadcrumb.service';
import { NgbActiveModal, NgbModal, NgbModalRef, NgbModule, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
// import { Mypipe } from '../../../service/datePipeService';

import _ from 'lodash';
import { IssueModelComponent } from '../../helper/issue-model/issue-model.component';
import { saveAs } from 'file-saver';
import { ElefantOrderDetailsComponent } from '../../helper/elefant-order-details/elefant-order-details.component';
import { LoaderService } from '../../../service/loaderService';
import { MapThemeService } from '../../../shared/services/map-theme.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import {
  ControlxActivity,
  ControlxActivityService,
  ControlxActivityView,
  ControlxError,
  ControlxErrorKind,
  ControlxStreamEvent,
  ControlxWatching,
  compareControlxEntriesDesc,
  controlxEntryId,
  formatControlxWatching,
  isControlxTerminalError,
  toControlxActivityView
} from '../../../core/controlx';

/** The ControlX rail's filter tabs. `all` is the resting state. */
export type ControlxTabKey = 'all' | 'decisions' | 'actions' | 'contacts';

/** A 3PL-panel row's sentence: "<name> <text>". See getAllocationNote. */
export interface AllocationNote {
  icon: 'assigned' | 'cancelled' | 'not-serviceable' | 'no-rider' | 'pending' | 'arrived'
  | 'picked-up' | 'transit' | 'delivered' | 'return' | 'info';
  text: string;
  tone: '' | 'danger' | 'warn' | 'muted' | 'brand';
  name: string;
  /** text is the partner's own message, shown after "name:" rather than as a sentence. */
  raw: boolean;
}

@Component({
  selector: 'app-order-detail-view',
  imports: [CommonModule, NgbModule],
  templateUrl: './order-detail-view.component.html',
  styleUrl: './order-detail-view.component.scss',
  // This view also opens as an NgbModal (live orders, reports, schedule). Its
  // tooltips use container="body", and the global tooltip layer (1049) sits
  // under the modal (1055), so they opened invisibly behind the dialog. Every
  // tooltip here gets `ad-od-tooltip`, which components/_tooltip.scss lifts
  // above the modal while one is open.
  providers: [{
    provide: NgbTooltipConfig,
    useFactory: () => Object.assign(new NgbTooltipConfig(), { tooltipClass: 'ad-od-tooltip' })
  }]
})
export class OrderDetailViewComponent implements OnInit, OnDestroy {
  orderId: any;
  reqfor: any;
  isModal: boolean = false;
  // map variables
  map: Leaflet.Map;
  lat: number = 0;
  long: number = 0;
  zoom: number = 13;

  orderData: any;
  orderNotFound: boolean = false;

  /**
   * First-load only. The view mounts before any data exists — the map's
   * setTimeout needs its container in the DOM, so the layout cannot be
   * withheld — which meant the modal opened showing a fully drawn but empty
   * shell and re-laid itself out when the response landed. This gates the
   * agentic loader that covers it until then (.ad-cx-loader, styled in
   * ui/_controlx.scss).
   *
   * Only ever set false, never back to true: getOrderDetails() also runs on
   * the 10s refresh interval, and a loader that reappeared every poll would
   * be worse than none.
   *
   * Cleared through finishOrderLoading(), not directly — see there for the
   * minimum-lifetime and fade-out timing.
   */
  isOrderLoading: boolean = true;

  /**
   * Set for the length of the loader's fade-out, while it is still mounted.
   * Drives `.ad-cx-loader.is-leaving`; `isOrderLoading` only goes false once
   * the fade has finished, so the node is never yanked mid-animation.
   */
  isOrderLoaderLeaving: boolean = false;

  /** When the loader first went up, for the minimum-lifetime maths. */
  private readonly orderLoaderStartedAt: number = Date.now();
  private orderLoaderHoldTimer: any = null;
  private orderLoaderExitTimer: any = null;

  /**
   * How long the loader stays up at minimum, and how long it takes to leave.
   * The hold exists because a warm response can land in under 100ms, and a
   * loader that appears and vanishes inside two frames reads as a flicker,
   * not as loading. The exit has to match the fade in `.ad-cx-loader.is-leaving`
   * (ui/_controlx.scss) — shorter here and the node disappears mid-fade.
   */
  private static readonly LOADER_MIN_MS = 600;
  private static readonly LOADER_EXIT_MS = 320;

  deliveryStaff: any = {};
  deliveryPartner: any = {};

  loggiSuggestion: string = '';
  swiggyTickets: any = [];
  thirdPartyAllocation: any = [];
  orderflows: any = [];
  // orderflows newest-first, for the Order Status timeline only. orderflows
  // itself stays chronological: the map, lastStatus, stampFlowRiderIcons and
  // getPendingRevertReason all read it in time order.
  orderflowsDesc: any[] = [];
  lastStatus: any = {};
  cancelledBy: any = {};
  riderPlatformName: string = '';
  supportTicket: any = [];
  riderSupport: any = [];

  // --- ControlX activity feed -------------------------------------------------
  // Fed by the ControlX API: a REST snapshot paints the rail, then an SSE stream
  // keeps it live. Rows the rail renders, newest first; empty is a legitimate
  // state (see controlxEmptyCaption), not necessarily a failure.
  private _controlxActivities: ControlxActivityView[] = [];
  get controlxActivities(): ControlxActivityView[] {
    return this._controlxActivities;
  }
  // A setter rather than a plain field so the three places that replace the
  // feed (snapshot, stream merge, fresh-flag expiry) cannot forget to refresh
  // the tab counts and the visible slice.
  set controlxActivities(views: ControlxActivityView[]) {
    this._controlxActivities = views;
    this.recomputeControlxTabs();
  }

  /**
   * Filter tabs over the feed.
   *
   * Decisions + Actions partition it, so their counts sum to All; Contacts is
   * a cross-cutting view of the rows that reached a human, not a fourth slice.
   * See ControlxGroup in the mapper for how a row is classified.
   */
  readonly controlxTabs: readonly { key: ControlxTabKey; label: string }[] = [
    { key: 'all', label: 'All' },
    { key: 'decisions', label: 'Decisions' },
    { key: 'actions', label: 'Actions' },
    { key: 'contacts', label: 'Contacts' }
  ];
  controlxTab: ControlxTabKey = 'all';
  controlxTabCounts: Record<ControlxTabKey, number> = { all: 0, decisions: 0, actions: 0, contacts: 0 };
  /** What the list renders — the active tab's rows, recomputed only on change. */
  controlxVisibleActivities: ControlxActivityView[] = [];

  /** Whether the snapshot has been fetched, and how it went. */
  controlxStatus: 'idle' | 'loading' | 'ready' | 'error' = 'idle';
  /** Live-connection state, surfaced as a tooltip rather than new chrome. */
  controlxStream: 'idle' | 'connecting' | 'live' | 'reconnecting' | 'offline' = 'idle';
  /** Set when the snapshot was asked for one order — lets an empty rail say why. */
  controlxWatching: ControlxWatching | null = null;
  controlxErrorKind: ControlxErrorKind | null = null;

  /**
   * Every entry seen, keyed by `activity.id`. The dedupe lives here rather than
   * in the array because snapshot, first-connect backfill and Last-Event-ID
   * replay all deliver overlapping rows by design.
   */
  private controlxEntries = new Map<string, ControlxActivity>();
  private controlxStreamSub?: Subscription;
  private readonly controlxStop$ = new Subject<void>();
  private controlxStarted: boolean = false;

  /**
   * Ids currently wearing the arrival highlight, and the timers that clear them.
   *
   * Presentation only — it never touches the dedupe map, the sort or the API.
   * A row is "new" for a few seconds after it lands on the stream, then goes
   * quiet like every other row.
   */
  private controlxFreshIds = new Set<string>();
  private controlxFreshTimers = new Map<string, any>();
  /** How long a row stays highlighted. Outlasts the CSS wash by a hair. */
  private readonly CONTROLX_FRESH_MS = 2600;
  /** Upper bound on retained rows — this page can stay open for a whole shift. */
  private readonly CONTROLX_MAX_ENTRIES = 200;

  /**
   * Whether the ControlX rail is part of this page at all — a separate
   * question from whether the feed has entries. The template both renders the
   * <aside> and sets `.ad-od--has-activity` from this one flag, so the grid
   * always has exactly as many tracks as there are columns.
   *
   * Gated on the order again. The previous attempt read `orderData.is_control_x`,
   * which the payload never carried, so the rail vanished on every order and the
   * flag was hardcoded `true` to get it back — which then showed the rail on
   * plain orders too. The field the API actually sends is nested:
   * `data.OrderDetail.controlx_order`.
   *
   * Kept loose about the value the same way `isControlxOrder` is in
   * live-orders.component.ts, so `1`, `"1"` and `true` all read as ControlX
   * while a missing key, `0` or `"0"` does not.
   *
   * A getter rather than a field, and that matters here: `initControlxActivity()`
   * runs once from ngOnInit — where only the order id is known and `orderData`
   * is still empty — and again from `orderProcessing()` after `orderData` is
   * assigned. A value captured at construction would still be false on the
   * second call and the feed would never start. Re-reading `orderData` makes
   * the first call a no-op and lets the second one open the stream.
   */
  get showControlxPanel(): boolean {
    const flag = this.orderData?.OrderDetail?.controlx_order
      ?? this.orderData?.OrderDetail?.is_control_x;
    return flag === true || Number(flag) === 1;
  }

  // Status-change background flash on the .ad-od workspace grid: a one-off,
  // 1s cue (see the ad-od-status-flash keyframes in the stylesheet) so a
  // status change is noticeable without being a distracting, repeating
  // animation. `previousOrderStatusId` starts null so the very first load
  // (not a "change") never flashes.
  showStatusFlash: boolean = false;
  private previousOrderStatusId: number | null = null;
  private statusFlashTimer: any;

  // --- Status typewriter ---------------------------------------------------
  // The status heading writes itself in a character at a time behind a blinking
  // caret, so a change reads as something being decided rather than a value
  // that silently swapped.
  //
  // Replays on a 5s loop so the line keeps reading as live, rather than
  // animating once on arrival and then sitting still for the whole delivery.
  //
  // Live orders only. On a delivered or cancelled order nothing is being worked
  // out any more, and animating the text there would claim activity that isn't
  // happening -- those get the finished string immediately.
  //
  // Driven from TS rather than a CSS steps() typewriter on purpose: these
  // strings vary a lot in length ("Pending" vs "Arrived at delivery") and a
  // width-based CSS typewriter has to be told the final width up front, so it
  // either clips the long labels or leaves dead space after the short ones.
  statusTyped: string = '';
  isStatusTyping: boolean = false;
  private statusTypeTarget: string | null = null;
  private statusTypeTimer: any = null;   // stepping through the characters of one pass
  private statusCycleTimer: any = null;  // the 5s heartbeat that replays that pass
  private static readonly STATUS_TYPE_MS = 45;
  private static readonly STATUS_REPEAT_MS = 5000;

  /**
   * Covers the Order Status card while a status transition settles.
   *
   * A status change rewrites the journey timeline, the status chip and every
   * surface tinted by --od-status at once. Left alone that lands as a hard cut
   * mid-read. This holds a small frosted cover over the card for
   * STATUS_LOADER_MS, then dissolves it, so the new state is revealed rather
   * than swapped in. Scoped to the one card on purpose: these arrive off the
   * socket every few minutes, and a full-page cover that often would be worse
   * than the cut it replaces.
   */
  isStatusUpdating: boolean = false;
  /** Drives `.ad-cx-loader.is-leaving`; see finishStatusLoading(). */
  isStatusLoaderLeaving: boolean = false;
  private statusLoaderHoldTimer: any = null;
  private statusLoaderExitTimer: any = null;
  private static readonly STATUS_LOADER_MS = 700;

  blockRiderReason: string = '';
  blockRiderPopup: boolean = false;

  public constant: any = constant;
  public commonLogics: any = commonLogics;
  dpData: any;
  orderUUid: any;
  trackorderDetails: any;
  locTrackDetails: any;
  riderCurrentLocationMarker: any;
  // --- Centralized route colors (Section 14) — used everywhere instead of scattering hex codes ---
  readonly ROUTE_COLORS = {
    assignToPickup: '#FF9800',   // orange: rider -> pickup, planned
    pickupToDelivery: '#2196F3', // blue: planned pickup -> delivery route
    riderTracking: '#4CAF50'     // green: rider's actual live GPS trail
  };
  // --- Route geometries (Section 13) — full OSRM road geometry, not straight lines ---
  assignToPickupRouteCoordinates: Leaflet.LatLng[] = [];
  pickupToDeliveryRouteCoordinates: Leaflet.LatLng[] = [];
  riderLiveRouteCoordinates: Leaflet.LatLng[] = [];
  // --- Map layers — exactly three polylines and no more: rider -> pickup, planned pickup ->
  // delivery, and the rider's live GPS trail. Plain polylines so a layer can be replaced without
  // ever ending up with duplicates on the map.
  private assignToPickupRouteLayer: any = null;
  private pickupToDeliveryRouteLayer: any = null;
  private riderLiveRouteLayer: any = null;
  // Pickup pin, delivery pin and one pin per order-flow status, held together so
  // they can be dropped as a unit. addOrderMarkers() runs from orderProcessing()
  // on every 10s poll, and these used to be added straight onto the map and kept
  // only in a local array for fitBounds — nothing held a reference, so nothing
  // could remove them and each poll stacked another full set into
  // .leaflet-marker-pane. A LayerGroup makes the previous set removable in one
  // call; see the clearLayers() at the top of addOrderMarkers().
  private orderMarkerLayer: any = null;
  // Kept so the expand toggle can reach the endpoint cards. Reassigned on every
  // rebuild, because clearLayers() detaches the previous pair.
  private pickupPointMarker: any = null;
  private deliveryPointMarker: any = null;
  // Which endpoint cards are open. Held on the component, not on the markers,
  // precisely because addOrderMarkers() throws the markers away every 10s poll
  // -- state on the marker would mean a card the user opened silently shut
  // itself a few seconds later.
  private pointTipOpen: { pickup: boolean; delivery: boolean } = { pickup: false, delivery: false };
  // fitBounds belongs to the first paint only. Re-running it every poll yanked
  // the view back and undid whatever the user had panned or zoomed to.
  private hasFitOrderMarkers: boolean = false;
  private osrmRouter: any = null;       // Leaflet.Routing.osrmv1() instance, reused across requests
  // --- Live rider location (Rider Location API feeds the routes/marker above) ---
  public riderLocation: { lat: number, lng: number } | null = null;
  public riderLocationLoading: boolean = false;
  public riderLocationError: boolean = false;
  private riderMarker: any = null; // bike-icon marker at the rider's current location
  private riderMarkerEl: any = null;    // cached DOM element of riderMarker, for the .is-idle class toggle
  private riderMarkerVehEl: any = null; // cached .ad-playhead__veh element, for heading rotation
  private riderHeadAngle: number = 0;   // accumulated bearing (deg) for smooth shortest-path turning
  private riderStartMarker: any = null; // marks the rider's first recorded ping (loc-track index 0), placed once and never moved
  private riderArrowLayer: any = null;  // direction arrows along the live trail; lives and dies with riderLiveRouteLayer
  private lastRoutedRiderLatLng: Leaflet.LatLng | null = null;
  private lastPlannedRouteKey: string = ''; // detects pickup/delivery coordinate changes
  private readonly ROUTE_DEVIATION_THRESHOLD_METERS = 100; // Section 12 — how far the rider must move before refreshAssignToPickupRoute() re-requests
  // Generous upper bound on rider travel speed, used only to reject impossible GPS jumps — real
  // delivery bikes/cars never approach this even in fast traffic. See filterGpsOutliers().
  private readonly MAX_PLAUSIBLE_RIDER_SPEED_MPS = 30; // ~108 km/h
  // --- Playback: replays the recorded GPS history, like the Rider Map trip-replay scrubber ---
  riderTrackPoints: { lat: number, lng: number, t: number }[] = [];
  riderPlaybackReady: boolean = false;
  isRiderPlaying: boolean = false;
  riderPlaybackSpeed: number = 1;
  riderPlaybackSpeedMenuOpen: boolean = false; // three-dot menu that reveals the speed options
  riderPlaybackProgress: number = 0; // 0..100, drives/driven-by the scrubber slider
  riderPlaybackIsIdle: boolean = false;
  riderPlaybackStartLabel: string = '';
  riderPlaybackEndLabel: string = '';
  riderPlaybackCurrentLabel: string = '';
  private riderPlaybackTStart: number = 0;
  private riderPlaybackTEnd: number = 0;
  private riderPlaybackCurrentT: number = 0;
  private riderPlaybackRafId: any = null;
  private riderPlaybackLastFrame: number = 0;
  private readonly RIDER_REPLAY_BASE_MS = 30000; // full track plays in ~30s at 1x
  loginUserId: any;
  buttonDisabled: boolean = false;
  canBlockRider: boolean = false;
  notificationList: any = [];
  @ViewChild("warning") modalWrning: TemplateRef<any>;
  dataNullCheck: boolean;
  proof_of_pickup: any;
  proof_of_delivery: any;
  proof_of_delivery_collection: any;
  proof_of_rto_delivered: any
  manualAssignedCheck: boolean = false;
  private refreshInterval: any;
  /** Releases the map's theme watcher; set when the map is created. */
  private disposeMapTheme?: () => void;
  private disposeMapResize?: () => void;
  private mapResizeFrame: number | null = null;

  /** Full-screen map. Drives `.is-expanded` on the map shell and the icon swap. */
  public isMapExpanded: boolean = false;

  /**
   * Proof lightbox. Null when closed; otherwise the three things the viewer
   * needs, all of which the tile it was opened from already had:
   *   src   - the same URL the <img> is bound to
   *   label - the tile's own caption, reused as the dialog's accessible name
   *   name  - the second argument DownloadImage() already takes
   * Nothing is fetched or derived, so the viewer adds no new data path: it is
   * the tile, larger.
   */
  public proofViewer: { src: string; label: string; name: string } | null = null;

  /** Where focus was when the viewer opened, so closing can put it back. */
  private proofViewerReturnFocus: HTMLElement | null = null;

  /** The viewer's root, for the tab trap. */
  @ViewChild('proofViewerEl') private proofViewerEl?: ElementRef<HTMLElement>;

  /**
   * Moves focus into the dialog the moment it exists. A setter rather than
   * ngAfterViewInit because the element is created and destroyed by @if, and a
   * ViewChild setter fires on exactly those two events.
   */
  @ViewChild('proofViewerClose') set proofViewerClose(el: ElementRef<HTMLButtonElement> | undefined) {
    el?.nativeElement.focus();
  }

  /**
   * 3PL Allocation bottom sheet. Enabled once there is anything to show it —
   * in practice that means the order has been assigned, since allocation
   * records only exist from that point on, but the flag reads straight off
   * the data rather than guessing it from order_status_id (whose numeric
   * order does not match the real status flow — see has3plAllocation).
   */
  public show3plSheet: boolean = false;

  /** Where focus was when the sheet opened, so closing can put it back. */
  private threePlSheetReturnFocus: HTMLElement | null = null;

  /** The sheet's root, for the tab trap. */
  @ViewChild('threePlSheetEl') private threePlSheetEl?: ElementRef<HTMLElement>;

  /**
   * Moves focus into the sheet the moment it exists — see proofViewerClose.
   * preventScroll: at that instant the panel is still at translateY(100%),
   * below the column, and a plain focus() scrolled the column down to reach
   * it — the jump seen when the sheet opened.
   */
  @ViewChild('threePlSheetClose') set threePlSheetClose(el: ElementRef<HTMLButtonElement> | undefined) {
    el?.nativeElement.focus({ preventScroll: true });
  }

  /** True while the sheet plays its exit animation, before it unmounts. */
  public is3plSheetClosing: boolean = false;
  private threePlSheetCloseTimer: any;
  /** Matches .ad-3pl-sheet.is-closing in the component SCSS. */
  private static readonly SHEET_EXIT_MS = 220;

  /**
   * Mobile-only (<768.98px) ControlX activities sheet. Unlike the 3PL sheet
   * this doesn't gate whether the aside is IN the DOM — the same
   * `<aside class="ad-od-col--activity">` is always there (it's the desktop
   * rail); this flag just toggles the `.is-open` class that slides it up as
   * a sheet at that breakpoint (see the component SCSS). Because the
   * element is never destroyed/recreated, there's no ViewChild-setter
   * moment to hook a focus move to (unlike threePlSheetClose above) — open/
   * closeControlxSheet() below call .focus() directly instead.
   */
  public showControlxSheet: boolean = false;

  /** Where focus was when the sheet opened, so closing can put it back. */
  private controlxSheetReturnFocus: HTMLElement | null = null;

  /** The sheet's root and close button, for the tab trap and open-focus. */
  @ViewChild('controlxSheetEl') private controlxSheetEl?: ElementRef<HTMLElement>;
  @ViewChild('controlxSheetClose') private controlxSheetCloseEl?: ElementRef<HTMLButtonElement>;

  /** The page's own overflow, so the scroll lock restores it rather than guessing. */
  private bodyOverflow: string = '';
  /**
   * Pixel inset kept clear around the rider's path when the map is expanded.
   * A fixed screen distance rather than a zoom level: the fit works out how
   * close it can get, this only says how much air to leave at the edges.
   */
  private readonly expandedFitPadding: number = 50;
  /** A re-frame is owed as soon as the container's new size is known. */
  private pendingMapFit: boolean = false;
  /** Where the small map was looking, so closing returns to it rather than to
   *  wherever the full-screen camera was left. */
  private collapsedView: { center: any, zoom: number } | null = null;
  /** 3-2-1 over the map before a replay starts; null whenever none is running. */
  public playCountdown: number | null = null;
  private playCountdownTimer: any = null;
  private reassignModalRef: NgbModalRef;

  constructor(private mapTheme: MapThemeService,
    private localData: LocalStorageService,
    private http: CommonHttpService,
    private activatedRoute: ActivatedRoute,
    private toaster: ToastrService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private modalService: NgbModal,
    private loder: LoaderService,
    private controlxActivity: ControlxActivityService,
    @Optional() public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    if (!this.isModal) {
      this.breadcrumbService.setBreadcrumb('Order Details');
    }
    // Get order_id from URL parameters
    this.activatedRoute.params.subscribe(params => {
      if (params['id']) {
        this.orderId = params['id'];
        this.orderNotFound = false;
      }
      // orderNotFound is set in the setTimeout below so modal-injected orderId is respected
    });

    // Get query parameters
    this.activatedRoute.queryParams.subscribe(queryParams => {
      if (queryParams['reqfor']) {
        this.reqfor = queryParams['reqfor'];
      }
    });
    if (this.orderId) {
      this.getDeliveryPartnerDetails();
      this.issueCheck();
    }
    // Get default coordinates from localStorage or use order data
    this.lat = this.orderData?.pickup_lat || parseFloat(this.localData.getItem(constant.localStorage.lat)) || 0;
    this.long = this.orderData?.pickup_long || parseFloat(this.localData.getItem(constant.localStorage.long)) || 0;
    this.loginUserId = this.commonLogics.getUserDetails();

    // Only proceed if we have an orderId
    this.refreshInterval = setInterval(() => {
      if ([constant.OrderStatusId.delivered, constant.OrderStatusId.cancelled, constant.OrderStatusId.RTODelivered].includes(this.orderData?.order_status_id)) {
        clearInterval(this.refreshInterval);
        return;
      }
      // console.log('Refreshing track order data...', this.orderData?.order_status_id);
      if (![constant.OrderStatusId.pending, constant.OrderStatusId.delivered, constant.OrderStatusId.cancelled, constant.OrderStatusId.RTODelivered].includes(this.orderData.order_status_id) || ![constant.OrderStatusId.pending, constant.OrderStatusId.delivered, constant.OrderStatusId.cancelled, constant.OrderStatusId.RTODelivered].includes(this.orderData.order_status_id) && this.reqfor != 'history')
        this.getDeliveryPartnerDetails();
      this.getTrackOrderRefresh();
      this.getOrderDetails();
      this.getLocTrack(); // keep the rider's live location (and route) up to date
    }, 10000)

    // Initialize map after view is ready
    setTimeout(() => {
      this.initializeMap();
      if (this.orderId) {
        this.getOrderDetails();
        this.getSwiggyTickets();
        this.getNotificationList()
        this.getLocTrack();
        // Started from here, and not from the top of ngOnInit, because the modal
        // host sets `orderId` on the instance after construction — this is the
        // first point at which it is known to be there.
        this.initControlxActivity();
      } else {
        // No id to fetch with, so nothing will ever clear this in
        // getOrderDetails() — the loader has to stop here instead.
        this.finishOrderLoading();
        this.orderNotFound = true;
        if (!this.isModal) {
          this.toaster.error('Order ID not found');
          if (window.history.length > 1) {
            window.history.back();
          } else {
            this.router.navigate(['/orders/list']);
          }
        }
      }
    }, 100);
    setTimeout(() => {
      if (!_.isUndefined(this.orderUUid) && !_.isEmpty(this.orderUUid) && !_.isNull(this.orderUUid)) {
        if (![constant.OrderStatusId.pending, constant.OrderStatusId.delivered, constant.OrderStatusId.cancelled].includes(this.orderData?.order_status_id) || ![constant.OrderStatusId.pending, constant.OrderStatusId.delivered, constant.OrderStatusId.cancelled].includes(this.orderData?.order_status_id) && this.reqfor != 'history')
          this.getTrackOrderRefresh();
      }
    }, 500);
  }
  //   getBlockRiderReason() {
  //   if ((commonLogics.roleCtrl([constant.RoleId.masterAgency], 'checkRoleIsEqual') && this.orderData.oo_master_agency_user_id == this.loginUserId) ||
  //     (commonLogics.roleCtrl([constant.RoleId.agency], 'checkRoleIsEqual') && this.orderData.oo_agency_user_id == this.loginUserId) || (commonLogics.roleCtrl([constant.RoleId.superAdmin, constant.RoleId.admin], 'checkRoleIsEqual'))) {
  //     this.buttonDisabled = false;
  //   } else {
  //     this.buttonDisabled = true;
  //   }
  // }

  // Visible: super admin, admin, SAAS / Customer master agency and agency.
  // Super admin, admin, SAAS master agency / agency: can block any rider (own, 3PL, other agencies').
  // Customer master agency / agency: only their under riders (no 3PL, no other agencies' / master agencies' riders).
  getBlockRiderReason() {
    const rider = this.orderData?.DeliveryStaff;
    const riderMasterAgencyId = rider?.MasterAgency?.user_id ?? rider?.master_agency_user_id;
    const riderAgencyId = rider?.Agency?.user_id ?? rider?.UnderAgency?.user_id ?? rider?.agency_user_id ?? rider?.UnderUser?.user_id ?? rider?.under_user_id;
    const isUnderRider = !!rider?.delivery_staff_id && [riderMasterAgencyId, riderAgencyId].some(id => id != null && id == this.loginUserId);
    const agencyType = this.localData.getItem(constant.localStorage.agency_type);
    const isAgencyRole = commonLogics.roleCtrl([constant.RoleId.masterAgency, constant.RoleId.agency], 'checkRoleIsEqual');
    const isAdminAccess = commonLogics.roleCtrl([constant.RoleId.superAdmin, constant.RoleId.admin], 'checkRoleIsEqual') || (isAgencyRole && agencyType == constant.typeOf.agency);
    const isCustomer = isAgencyRole && agencyType == constant.typeOf.group;
    // TEMP debug: remove after verifying block rider ownership fields
    // console.log('[BlockRider]', { loginUserId: this.loginUserId, riderMasterAgencyId, riderAgencyId, isUnderRider, isAdminAccess, isCustomer });
    this.canBlockRider = isAdminAccess || isCustomer;
    if (isAdminAccess || (isCustomer && isUnderRider)) {
      this.buttonDisabled = false;
    } else {
      this.buttonDisabled = true;
    }
  }

  getTrackOrderRefresh() {
    let url: any = constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.TrackOrderRefresh + '/' + this.orderUUid;
    this.http.get(url).subscribe((response: any) => {
      this.trackorderDetails = response.data;
      this.commonFunction(response.data);
    })
  }

  // Rider Location API — polled on the same cadence as the rest of the order refresh (see the
  // refreshInterval in ngOnInit), so the rider's position and the tracking routes stay live.
  getLocTrack() {
    this.riderLocationLoading = true;
    let url: any = constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.LocTrack + this.orderId;
    this.http.get(url).subscribe((response: any) => {
      this.locTrackDetails = response.data;
      this.riderLocationLoading = false;
      this.riderLocationError = false;
      this.addRiderStartMarker();
      this.preparePlayback();
      this.updateRiderLocation();
    }, (error) => {
      console.error('Error fetching rider location:', error);
      this.riderLocationLoading = false;
      this.riderLocationError = true;
      // Gracefully fall back — leave whatever route is already on the map (base or rider) as-is.
    });
  }

  // Marks the rider's first recorded location — index 0 of the raw loc-track response, exactly
  // as returned by the API (no sorting/filtering). Placed once and never moved: it's a fixed
  // historical fact about where the rider was when tracking began, unlike the live rider marker.
  private addRiderStartMarker() {
    if (this.riderStartMarker || !this.map) return;
    const first = this.locTrackDetails?.[0];
    if (!first || !this.isValidCoordinate(first.rider_lat, first.rider_long)) return;
    this.riderStartMarker = Leaflet.marker(
      [Number(first.rider_lat), Number(first.rider_long)],
      { icon: constant.mapIcons.riderStartIcon }
    ).addTo(this.map);
    this.riderStartMarker.bindTooltip('Rider start', {
      direction: 'top',
      offset: [0, -18],
      className: 'order-status-tooltip'
    });
  }

  // Full GPS history from the loc-track records, sorted by time, valid coordinates only, with
  // stale/duplicate pings filtered out (see filterGpsOutliers).
  private getRiderTrackHistory(): { lat: number, lng: number, t: number }[] {
    const points = (this.locTrackDetails || [])
      .filter((item: any) => this.isValidCoordinate(item?.rider_lat, item?.rider_long))
      // ctd_dt carries no timezone marker but is a UTC value (same convention as orderDateFormat()
      // elsewhere in this file) — parse it as UTC so the resulting epoch ms is the correct absolute
      // instant; every downstream .format() call (playback labels, marker tooltip) then renders it
      // in the browser's local time automatically, since plain moment(epochMs) defaults to local.
      .map((item: any) => ({ lat: Number(item.rider_lat), lng: Number(item.rider_long), t: moment.utc(item?.ctd_dt).valueOf() }))
      .sort((a: any, b: any) => a.t - b.t);
    return this.filterGpsOutliers(points);
  }

  // The delivery-partner platform occasionally replays a stale/cached ping — most visibly, an
  // exact repeat of an earlier coordinate (e.g. the pickup point) while the rider is clearly
  // elsewhere. Left in, that snaps the rider marker/trail backward, then forward again as soon
  // as real pings resume.
  //
  // A plain "reject anything too fast from the last accepted point" gate isn't enough: once
  // enough real time has elapsed, even a bogus jump can average out to a plausible speed and get
  // accepted — which then makes the genuinely-real point right after it look like the impossible
  // jump instead, dropping good data. So every implausible jump is instead confirmed by looking
  // ahead to whichever later point is the first to look plausible again: if that point lines up
  // with where we already were, the jump was a transient blip (drop it and everything up to the
  // point that resumes the real trend); if it lines up with the jump itself, treat the jump as a
  // real — if abrupt — move and keep it. A jump that's never resolved before the data ends is
  // left unconfirmed and the trail simply stops there rather than showing an unverified leap.
  private filterGpsOutliers(points: { lat: number, lng: number, t: number }[]): { lat: number, lng: number, t: number }[] {
    if (points.length < 2) return points;
    const speedMps = (a: { lat: number, lng: number, t: number }, b: { lat: number, lng: number, t: number }) =>
      Leaflet.latLng(a.lat, a.lng).distanceTo(Leaflet.latLng(b.lat, b.lng)) / Math.max((b.t - a.t) / 1000, 1);

    const accepted: { lat: number, lng: number, t: number }[] = [points[0]];
    let i = 1;
    while (i < points.length) {
      const last = accepted[accepted.length - 1];
      const candidate = points[i];
      if (speedMps(last, candidate) <= this.MAX_PLAUSIBLE_RIDER_SPEED_MPS) {
        accepted.push(candidate);
        i++;
        continue;
      }
      let j = i + 1;
      while (j < points.length && speedMps(last, points[j]) > this.MAX_PLAUSIBLE_RIDER_SPEED_MPS) j++;
      if (j >= points.length) break; // never resolved — stop the trail rather than guess

      const resumesNearJump = Leaflet.latLng(candidate.lat, candidate.lng).distanceTo(Leaflet.latLng(points[j].lat, points[j].lng))
        < Leaflet.latLng(last.lat, last.lng).distanceTo(Leaflet.latLng(points[j].lat, points[j].lng));
      if (resumesNearJump) {
        accepted.push(candidate); // a real (if abrupt) move — what follows confirms it
        i++;
      } else {
        i = j; // transient blip — skip everything up to the point that resumes the real trend
      }
    }
    return accepted;
  }

  // Resolves the same rider/bike icon used for the live current-location marker — the same
  // pulsing top-down scooter used for the Delivery Staff map's trip-replay playhead.
  private getRiderIcon(): any {
    var url = window?.location?.origin;
    if (url.includes('child')) {
      return constant.mapIcons.riderBike;
    }
    return Leaflet.divIcon({
      className: 'ad-playhead',
      html: this.riderMarkerHtml(),
      iconSize: [48, 48],
      iconAnchor: [24, 24]
    });
  }
  // never resolved — stop the trail rather than guess
  // Same markup as the Delivery Staff map's playheadHtml(): a location-pulse halo behind a
  // top-down 3D-style scooter (nose points up, rotated to heading via .ad-playhead__veh).
  private riderMarkerHtml(): string {
    return `<span class="ad-playhead__pulse"></span>
      <div class="ad-playhead__veh">
        <svg viewBox="0 0 56 68" width="48" height="48" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="phBody" x1="0.15" y1="0" x2="0.9" y2="1">
              <stop offset="0" stop-color="#d7f25e"/><stop offset="0.5" stop-color="#a7cd12"/><stop offset="1" stop-color="#6f8b00"/>
            </linearGradient>
            <linearGradient id="phBox" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stop-color="#8fb200"/><stop offset="1" stop-color="#4f6600"/>
            </linearGradient>
            <radialGradient id="phHelm" cx="0.36" cy="0.3" r="0.9">
              <stop offset="0" stop-color="#6a7079"/><stop offset="0.55" stop-color="#3a3f48"/><stop offset="1" stop-color="#171a20"/>
            </radialGradient>
            <radialGradient id="phTire" cx="0.5" cy="0.5" r="0.6">
              <stop offset="0" stop-color="#3a3f48"/><stop offset="1" stop-color="#14161b"/>
            </radialGradient>
          </defs>

          <!-- soft ground shadow -->
          <ellipse cx="28" cy="60" rx="15" ry="4.6" fill="rgba(0,0,0,0.26)"/>

          <!-- wheels -->
          <rect x="21" y="4"  width="14" height="16" rx="7" fill="url(#phTire)"/>
          <rect x="21" y="47" width="14" height="17" rx="7" fill="url(#phTire)"/>
          <rect x="23.5" y="7"  width="9" height="10" rx="4.5" fill="#20242b"/>
          <rect x="23.5" y="50" width="9" height="11" rx="4.5" fill="#20242b"/>

          <!-- mirrors -->
          <path d="M14 20 L11 15" stroke="#2b2f38" stroke-width="1.6" stroke-linecap="round"/>
          <path d="M42 20 L45 15" stroke="#2b2f38" stroke-width="1.6" stroke-linecap="round"/>
          <circle cx="10.5" cy="14" r="2.3" fill="#3b414b"/><circle cx="45.5" cy="14" r="2.3" fill="#3b414b"/>

          <!-- handlebar + grips -->
          <rect x="11" y="17" width="34" height="5.5" rx="2.75" fill="#2a2e36"/>
          <circle cx="11.5" cy="19.7" r="3" fill="#3a3f48"/><circle cx="44.5" cy="19.7" r="3" fill="#3a3f48"/>

          <!-- scooter body + gloss -->
          <rect x="15" y="13" width="26" height="42" rx="13" fill="url(#phBody)" stroke="rgba(0,0,0,0.18)" stroke-width="0.8"/>
          <rect x="19" y="16" width="7" height="34" rx="3.5" fill="#ffffff" opacity="0.20"/>

          <!-- arms to the grips -->
          <path d="M24 30 L13.5 21" stroke="#31353f" stroke-width="5" stroke-linecap="round"/>
          <path d="M32 30 L42.5 21" stroke="#31353f" stroke-width="5" stroke-linecap="round"/>

          <!-- delivery box (rear, raised) -->
          <rect x="17.5" y="44" width="21" height="16" rx="3" fill="url(#phBox)" stroke="rgba(0,0,0,0.2)" stroke-width="0.8"/>
          <rect x="20" y="46.5" width="16" height="7" rx="1.6" fill="#c7e94a" opacity="0.85"/>
          <circle cx="28" cy="50" r="2.1" fill="#3f5200"/>

          <!-- rider torso / jacket -->
          <path d="M18 30 q10 -8 20 0 l-2.4 10 q-7.6 3.6 -15.2 0 z" fill="#2f333c"/>

          <!-- helmet (sphere) + visor + highlight -->
          <circle cx="28" cy="23" r="9.4" fill="url(#phHelm)"/>
          <path d="M18.9 21.4 a9.4 9.4 0 0 1 18.2 0 q-9.1 -3.4 -18.2 0 z" fill="#a6dcff" opacity="0.92"/>
          <ellipse cx="23.5" cy="18.5" rx="3" ry="1.7" fill="rgba(255,255,255,0.5)" transform="rotate(-24 23.5 18.5)"/>
        </svg>
      </div>`;
  }

  // Compass bearing (deg, clockwise from north) from point a to point b, or null if they're
  // effectively the same point (no movement -> caller keeps the last heading).
  private bearingBetween(a: { lat: number, lng: number }, b: { lat: number, lng: number }): number | null {
    const dLat = b.lat - a.lat, dLng = b.lng - a.lng;
    if (Math.hypot(dLat, dLng) < 1e-9) return null;
    const lat0 = ((a.lat + b.lat) / 2) * Math.PI / 180;
    return Math.atan2(dLng * Math.cos(lat0), dLat) * 180 / Math.PI;
  }

  // Rotates .ad-playhead__veh to `bearing`, always turning the short way around (accumulates the
  // nearest equivalent angle rather than snapping), matching the Delivery Staff map's playhead.
  private applyRiderHeading(bearing: number | null): void {
    if (bearing == null || !this.riderMarkerVehEl) return;
    let delta = bearing - this.riderHeadAngle;
    delta = ((delta % 360) + 540) % 360 - 180;
    this.riderHeadAngle += delta;
    this.riderMarkerVehEl.style.transform = `rotate(${this.riderHeadAngle}deg)`;
  }

  // Updates the permanent time tooltip and the .is-idle pulse color on the rider marker.
  private updateRiderMarkerBadge(timestampMs: number, idle: boolean): void {
    if (!this.riderMarker) return;
    this.riderMarker.setTooltipContent(moment(timestampMs).format('hh:mm:ss A'));
    const el = this.riderMarkerEl || (this.riderMarker.getElement && this.riderMarker.getElement());
    if (el) el.classList.toggle('is-idle', !!idle);
  }

  // Lazily creates (and reuses) the OSRM router used to fetch full road geometry. This calls
  // OSRM directly (not the full Routing.control widget) so the raw coordinates can be stored,
  // styled, and split (green/blue) ourselves instead of drawing a straight line.
  private requestOsrmRoute(from: Leaflet.LatLng, to: Leaflet.LatLng): Promise<Leaflet.LatLng[]> {
    if (!this.osrmRouter) {
      this.osrmRouter = (Leaflet.Routing as any).osrmv1({});
    }
    return new Promise((resolve) => {
      try {
        // osrmv1().route() expects Waypoint objects ({ latLng }), not raw L.LatLng instances —
        // passing raw LatLngs leaves wp.latLng undefined and buildRouteUrl throws on latLng.lng.
        const waypoints = [from, to].map(latLng => (Leaflet.Routing as any).waypoint(latLng));
        this.osrmRouter.route(waypoints, (err: any, routes: any[]) => {
          if (err || !routes || !routes.length) {
            console.error('OSRM route request failed:', err);
            resolve([]); // caller keeps whatever geometry it already had rather than falling back to a straight line
            return;
          }
          resolve(routes[0].coordinates);
        });
      } catch (ex) {
        // Never let a routing-library exception reject this promise — an uncaught rejection here
        // would abort the awaiting async chain (updateRiderLocation) before it reaches the
        // status-based render calls, which looks exactly like "API succeeded, polyline never updates".
        console.error('OSRM route request threw:', ex);
        resolve([]);
      }
    });
  }

  private plannedRouteKey(): string {
    return `${this.orderData?.pickup_lat},${this.orderData?.pickup_long}|${this.orderData?.delivery_lat},${this.orderData?.delivery_long}`;
  }

  // Section 4 — the planned Pickup -> Delivery route. Computed once and reused; only
  // re-requested if the pickup/delivery coordinates themselves change (see plannedRouteKey()).
  private async updatePickupToDeliveryRoute() {
    if (!this.isValidCoordinate(this.orderData?.pickup_lat, this.orderData?.pickup_long) ||
      !this.isValidCoordinate(this.orderData?.delivery_lat, this.orderData?.delivery_long)) {
      return;
    }
    const pickup = Leaflet.latLng(Number(this.orderData.pickup_lat), Number(this.orderData.pickup_long));
    const delivery = Leaflet.latLng(Number(this.orderData.delivery_lat), Number(this.orderData.delivery_long));
    const coords = await this.requestOsrmRoute(pickup, delivery);
    if (!coords.length) return;
    this.pickupToDeliveryRouteCoordinates = coords;
    this.lastPlannedRouteKey = this.plannedRouteKey();
  }

  private renderPickupToDeliveryLayer() {
    if (this.pickupToDeliveryRouteLayer) {
      this.map.removeLayer(this.pickupToDeliveryRouteLayer);
      this.pickupToDeliveryRouteLayer = null;
    }
    if (!this.pickupToDeliveryRouteCoordinates.length) return;
    this.pickupToDeliveryRouteLayer = Leaflet.polyline(this.pickupToDeliveryRouteCoordinates, {
      color: this.ROUTE_COLORS.pickupToDelivery, weight: 5, opacity: 0.85
    }).addTo(this.map);
  }

  // The blue route only needs the order's pickup/delivery coordinates — not rider GPS — so it's
  // computed and shown independently of live rider tracking. Called both right after the order's
  // markers are placed (so it appears even before any rider location ping ever arrives) and from
  // refreshTrackingRoutes() (to pick up a pickup/delivery coordinate change once tracking starts).
  private async ensurePickupToDeliveryRoute() {
    const routeKey = this.plannedRouteKey();
    if (!this.pickupToDeliveryRouteCoordinates.length || routeKey !== this.lastPlannedRouteKey) {
      await this.updatePickupToDeliveryRoute();
      this.autoFitRoutes();
    }
    this.renderPickupToDeliveryLayer();
  }

  // Section 3 — Rider -> Pickup (orange). Re-requested only once the rider has moved past the
  // deviation threshold since the last request, never on every GPS tick.
  private async refreshAssignToPickupRoute(riderLatLng: Leaflet.LatLng) {
    const needsRoute = !this.assignToPickupRouteCoordinates.length ||
      !this.lastRoutedRiderLatLng ||
      riderLatLng.distanceTo(this.lastRoutedRiderLatLng) > this.ROUTE_DEVIATION_THRESHOLD_METERS;
    if (!needsRoute) return;
    if (!this.isValidCoordinate(this.orderData?.pickup_lat, this.orderData?.pickup_long)) return;

    const pickup = Leaflet.latLng(Number(this.orderData.pickup_lat), Number(this.orderData.pickup_long));
    const coords = await this.requestOsrmRoute(riderLatLng, pickup);
    if (!coords.length) return;

    // OSRM snaps the origin to the nearest routable road, which can sit a few metres away from
    // the rider's raw GPS point — pin the line to the marker's exact position so it never
    // visually detaches from it.
    this.assignToPickupRouteCoordinates = [riderLatLng, ...coords];
    this.lastRoutedRiderLatLng = riderLatLng;
    this.renderAssignToPickupLayer();
    this.autoFitRoutes(); // rider moved enough to reroute — a significant change, worth re-framing
  }

  private renderAssignToPickupLayer() {
    if (this.assignToPickupRouteLayer) {
      this.map.removeLayer(this.assignToPickupRouteLayer);
      this.assignToPickupRouteLayer = null;
    }
    if (!this.assignToPickupRouteCoordinates.length) return;
    this.assignToPickupRouteLayer = Leaflet.polyline(this.assignToPickupRouteCoordinates, {
      color: this.ROUTE_COLORS.assignToPickup, weight: 5, opacity: 0.9
    }).addTo(this.map);
  }

  private clearAssignToPickupRoute() {
    if (this.assignToPickupRouteLayer) {
      this.map.removeLayer(this.assignToPickupRouteLayer);
      this.assignToPickupRouteLayer = null;
    }
    this.assignToPickupRouteCoordinates = [];
  }

  // The rider's actual recorded path — real GPS pings connected in order, not an estimate.
  // Doesn't depend on OSRM at all, so it renders even if the planned-route request fails.
  private getRiderGpsTrail(): Leaflet.LatLng[] {
    return this.getRiderTrackHistory().map(p => Leaflet.latLng(p.lat, p.lng));
  }

  // The rider-live polyline — always the rider's full real GPS trail so far, for the life of the
  // order. Doesn't split or reroute against the planned route; it's just "everywhere the rider's
  // actually been".
  private renderRiderLiveLayer() {
    if (this.riderLiveRouteLayer) { this.map.removeLayer(this.riderLiveRouteLayer); this.riderLiveRouteLayer = null; }
    if (this.riderLiveRouteCoordinates.length > 1) {
      this.riderLiveRouteLayer = Leaflet.polyline(this.riderLiveRouteCoordinates, {
        color: this.ROUTE_COLORS.riderTracking, weight: 5, opacity: 0.9
      }).addTo(this.map);
    }
    // Rebuilt with the line, from the same coordinates, so the two can never
    // disagree about where the trail goes.
    this.renderRiderDirectionArrows();
  }

  private clearRiderLiveLayer() {
    if (this.riderLiveRouteLayer) { this.map.removeLayer(this.riderLiveRouteLayer); this.riderLiveRouteLayer = null; }
    this.clearRiderDirectionArrows();
    this.riderLiveRouteCoordinates = [];
  }

  private clearRiderDirectionArrows() {
    if (this.riderArrowLayer) { this.map.removeLayer(this.riderArrowLayer); this.riderArrowLayer = null; }
  }

  /**
   * White direction arrows along the rider's trail — the same treatment the
   * Delivery Staff trip replay gives its route (`.ad-route-arrow` there and
   * here), so a green line read on either screen says which way it was
   * travelled without having to play it back.
   *
   * Spaced by DISTANCE, not by point. loc-track pings arrive at whatever
   * interval the device managed, so one arrow per point would pack a dozen into
   * a traffic queue and leave a fast leg bare — the arrows would end up
   * describing the GPS sampling rate rather than the route.
   *
   * The step adapts, which is the one place this departs from the Delivery
   * Staff map. That screen replays a whole shift and can afford a flat 500m;
   * these are single orders, and the reference trips on this view run 0.3-2km —
   * at 500m a third of them would get no arrow at all. Aiming for a dozen along
   * whatever the trail turns out to be keeps a 300m hop and a 20km haul equally
   * legible, with a 120m floor so a short trip is annotated rather than
   * stippled.
   */
  private renderRiderDirectionArrows(): void {
    this.clearRiderDirectionArrows();

    const pts = this.riderLiveRouteCoordinates;
    if (!this.map || pts.length < 2) return;

    // First pass for the total, because the spacing depends on it.
    let total = 0;
    for (let i = 0; i < pts.length - 1; i++) total += pts[i].distanceTo(pts[i + 1]);
    if (total < 60) return; // shorter than one arrow's worth of route

    const TARGET_ARROWS = 12;
    const MAX_ARROWS = 400;  // safety cap, matching the Delivery Staff map
    const step = Math.max(120, total / TARGET_ARROWS);

    const layer = Leaflet.layerGroup();
    let acc = 0;             // metres walked so far
    let nextMark = step;     // distance at which the next arrow lands
    let count = 0;

    for (let i = 0; i < pts.length - 1 && count < MAX_ARROWS; i++) {
      const a = pts[i], b = pts[i + 1];
      const segLen = a.distanceTo(b);
      if (segLen <= 0) continue;

      // Reuses the playhead's own bearing helper, so an arrow and the scooter
      // standing on it always point the same way.
      const angle = this.bearingBetween(a, b);
      if (angle == null) { acc += segLen; continue; }

      while (nextMark <= acc + segLen && count < MAX_ARROWS) {
        const f = (nextMark - acc) / segLen; // fraction into this segment
        const lat = a.lat + (b.lat - a.lat) * f;
        const lng = a.lng + (b.lng - a.lng) * f;
        layer.addLayer(Leaflet.marker([lat, lng], {
          interactive: false,
          keyboard: false,
          // Negative, so an arrow can never paint over the rider or the start
          // pin. Markers sit in their own pane above every polyline whatever
          // this is, so the arrows still read as being on the line.
          zIndexOffset: -500,
          icon: Leaflet.divIcon({
            className: 'ad-route-arrow',
            html: '<div class="ad-route-arrow__i" style="transform:rotate(' + angle + 'deg)">'
              + '<svg viewBox="0 0 24 24" width="12" height="12">'
              + '<path d="M12 3L19 20L12 15.5L5 20Z" fill="#fff" stroke="rgba(0,0,0,0.45)" stroke-width="1" stroke-linejoin="round"/>'
              + '</svg></div>',
            iconSize: [14, 14],
            iconAnchor: [7, 7],
          }),
        }));
        nextMark += step;
        count++;
      }
      acc += segLen;
    }

    if (count) this.riderArrowLayer = layer.addTo(this.map);
  }

  /**
   * The automatic re-frame — used by the two places the map refits itself when
   * data lands: a freshly routed pickup→delivery leg, and a reroute after the
   * rider has moved far enough to warrant one.
   *
   * Expanded, the frame belongs to the rider's path. `fitAllRoutes()` below also
   * takes in the planned pickup→delivery line, which is a far bigger box — so
   * letting it run here would undo the tight fit within a refresh tick of
   * opening the view, which is exactly the zoom-out this view exists to avoid.
   *
   * Mid-replay it does nothing at all: the camera was placed for the replay and
   * a poll landing halfway through is no reason to move it.
   *
   * Deliberate refits — the Reset button — call `fitAllRoutes()` directly and are
   * never suppressed by any of this.
   */
  private autoFitRoutes(): void {
    if (!this.map) return;
    if (this.isRiderPlaying) return;

    if (this.isMapExpanded) {
      const journey = this.riderJourneyBounds();
      if (journey) {
        const insets = this.expandedFitInsets();
        // Not animated: this fires off a data refresh, not off a click, so it
        // should settle the frame rather than perform a move.
        this.map.fitBounds(journey, {
          paddingTopLeft: insets.topLeft,
          paddingBottomRight: insets.bottomRight,
          animate: false
        });
        return;
      }
    }

    this.fitAllRoutes();
  }

  // Fits the map to whatever routes currently exist — called only on initial route load, never
  // on every GPS tick (Section 20), so the camera doesn't jump around during live tracking.
  private fitAllRoutes() {
    const allCoords = [
      ...this.pickupToDeliveryRouteCoordinates,
      ...this.assignToPickupRouteCoordinates,
      ...this.riderLiveRouteCoordinates
    ];
    // Explicitly include the rider's own position — the planned route alone can leave the rider
    // outside the frame once they've deviated from it.
    if (this.riderMarker) allCoords.push(this.riderMarker.getLatLng());
    if (!allCoords.length || !this.map) return;
    this.map.fitBounds(Leaflet.latLngBounds(allCoords).pad(0.15));
  }

  // Main orchestration (Section 15) — called whenever fresh rider-location data comes in.
  // Moves/creates the rider marker and keeps exactly three polylines in sync: orange
  // (rider -> pickup, pre-pickup only), blue (planned pickup -> delivery, always), and green
  // (the rider's live GPS trail, always).
  async updateRiderLocation() {
    if (!this.map) return;

    const history = this.getRiderTrackHistory();
    //console.log('Latest rider location:', history[history.length - 1], 'from', this.locTrackDetails?.length, 'records');
    if (!history.length) {
      this.riderLocation = null;
      return;
    }

    const latest = history[history.length - 1];
    const previous = history.length > 1 ? history[history.length - 2] : null;
    this.riderLocation = { lat: latest.lat, lng: latest.lng };
    const riderLatLng = Leaflet.latLng(latest.lat, latest.lng);

    if (!this.riderMarker) {
      this.riderMarker = Leaflet.marker(riderLatLng, { icon: this.getRiderIcon(), zIndexOffset: 1000 }).addTo(this.map);
      this.riderMarker.bindTooltip('', { permanent: true, direction: 'top', offset: [0, -22], className: 'ad-playhead-time' });
      this.riderMarkerEl = this.riderMarker.getElement ? this.riderMarker.getElement() : null;
      this.riderMarkerVehEl = this.riderMarkerEl ? this.riderMarkerEl.querySelector('.ad-playhead__veh') : null;
      // Seed the initial heading so it starts facing the right way (no spin on first frame).
      this.riderHeadAngle = (previous && this.bearingBetween(previous, latest)) || 0;
      if (this.riderMarkerVehEl) this.riderMarkerVehEl.style.transform = `rotate(${this.riderHeadAngle}deg)`;
    } else if (!this.isRiderPlaying) {
      this.riderMarker.setLatLng(riderLatLng);
      if (previous) this.applyRiderHeading(this.bearingBetween(previous, latest));
    }

    if (!this.isRiderPlaying) {
      const idle = !!previous && Leaflet.latLng(previous.lat, previous.lng).distanceTo(riderLatLng) < 12;
      this.updateRiderMarkerBadge(latest.t, idle);
    }

    try {
      await this.refreshTrackingRoutes(riderLatLng);
    } catch (ex) {
      console.error('Failed to refresh tracking routes:', ex);
    }
  }

  getFlowPartnerName(flow: any): string {
    if (flow?.order_status_id !== constant.OrderStatusId.assigned) return '';
    const matchedFlow = (this.thirdPartyAllocation || []).find((f: any) => f.order_status_id == flow.order_status_id && f.date_time === flow.date_time);
    return matchedFlow?.delivery_staff_id ? 'Ek-bharat'
      : matchedFlow?.delivery_partner_user_id ? (matchedFlow?.DeliveryPartner?.full_name || '')
        : '';
  }

  // Stamps `__riderIcon` on each status-timeline row: the image of whoever held
  // the order at that point. Flows carry no image of their own, so an Assigned
  // row is matched to its allocation (same key as getFlowPartnerName) and the
  // image carries forward until a revert to Pending clears it. Rows with no
  // rider yet get none and keep the status letter. Flows and allocations load
  // from separate requests, so this runs after either one lands.
  private stampFlowRiderIcons(): void {
    const staffIcon = 'assets/images/avatar/3pl/ek-bharat.png';
    let current = '';
    let lastAssigned: any = null;
    (this.orderflows || []).forEach((flow: any) => {
      flow.__rider = null;
      flow.__isCurrentAssign = false;
      if (flow?.order_status_id === constant.OrderStatusId.pending) {
        current = '';
        lastAssigned = null;
      } else if (flow?.order_status_id === constant.OrderStatusId.assigned) {
        const matched = (this.thirdPartyAllocation || []).find((f: any) =>
          f.order_status_id == flow.order_status_id && f.date_time === flow.date_time);
        current = matched?.delivery_staff_id ? staffIcon
          : matched?.DeliveryPartner?.icon_url ? matched.DeliveryPartner.icon_url
            : flow?.delivery_staff_id ? staffIcon
              : this.lastStatus?.iconUrl || staffIcon;
        // Rider who took this assignment, when the allocation carries one
        // (our own fleet). Older 3PL attempts have no rider details.
        const staff = matched?.DeliveryStaff;
        const phone = staff?.phone
          || this.riderPhoneFromFlowId(matched?.order_flow_id)
          || this.riderPhoneFromFlowId(flow?.order_flow_id);
        if (staff?.full_name || phone) {
          flow.__rider = {
            full_name: staff?.full_name,
            phone,
            delivery_staff_id: matched?.delivery_staff_id ?? staff?.delivery_staff_id,
            delivery_partner_user_id: staff ? null : (matched?.DeliveryPartner?.user_id ?? matched?.user_id),
          };
        }
        lastAssigned = flow;
      }
      flow.__riderIcon = current;
    });
    // The assignment still holding the order (no revert to Pending after it)
    // falls back to the order's current rider, which also covers 3PL riders.
    if (lastAssigned) lastAssigned.__isCurrentAssign = true;
  }

  // A 3PL assignment's flow carries no rider details, but its id embeds the
  // rider's phone: `{order_id}_{status}_{3pl user_id}_{rider phone}_{HHmmss}`,
  // e.g. 247590973_3_690_6309569766_071029.
  private riderPhoneFromFlowId(flowId: any): string {
    const parts = String(flowId ?? '').split('_');
    if (parts.length < 5 || parts[1] != String(constant.OrderStatusId.assigned)) return '';
    return /^\+?\d{10,13}$/.test(parts[3]) ? parts[3] : '';
  }

  // Rider name/phone shown under Track on an Assigned timeline row.
  getFlowRider(flow: any): { full_name?: string; phone?: string } | null {
    if (flow?.order_status_id !== constant.OrderStatusId.assigned) return null;
    const current = this.deliveryStaff;
    const hasCurrent = !!(current?.full_name || current?.phone);
    const rider = flow.__rider;
    if (rider) {
      // 3PL row: only the phone is known; the name comes from the order's
      // current rider when this row is that rider.
      if (!rider.full_name && rider.phone) {
        const sameRider = flow.__isCurrentAssign || (current?.phone && String(current.phone).slice(-10) == rider.phone.slice(-10));
        return { full_name: sameRider ? current?.full_name : '', phone: rider.phone };
      }
      // Allocation rows carry the rider's name but not always the phone; take
      // it from the order's rider when this row is that same rider.
      if (!rider.phone) {
        const orderStaff = this.orderData?.DeliveryStaff;
        const sameRider = flow.__isCurrentAssign
          || (rider.delivery_staff_id && rider.delivery_staff_id == orderStaff?.delivery_staff_id);
        if (sameRider) {
          return { full_name: rider.full_name, phone: orderStaff?.phone || current?.phone };
        }
      }
      return rider;
    }
    return flow.__isCurrentAssign && hasCurrent ? current : null;
  }

  getPendingRevertReason(flow: any, index: number): string {
    if (flow?.order_status_id !== constant.OrderStatusId.pending) return '';
    const previousFlow = this.orderflows?.[index - 1];
    if (previousFlow?.order_status_id !== constant.OrderStatusId.assigned) return '';
    const description = flow?.order_cancel_description || '';
    // e.g. "Manual-reassignment" -> "reassignment": only the part after the first '-' is
    // shown, the prefix before it (who/what triggered it) isn't relevant to the card.
    // const dashIndex = description.indexOf('-');
    // return dashIndex >= 0 ? description.substring(dashIndex + 1).trim() : description;
    const dashIndex = description;
    return dashIndex;
  }

  // Chip styling for a getPendingRevertReason() text: "Cancelled by Shadowfax"
  // reads as a cancellation, "reassignment" as a reassign, anything else neutral.
  getRevertReasonChip(reason: string): { kind: 'cancelled' | 'reassign' | 'info'; label: string; hint: string } {
    const text = (reason || '').trim();
    const label = text.charAt(0).toUpperCase() + text.slice(1);
    const lower = text.toLowerCase();
    if (lower.includes('cancel')) {
      return { kind: 'cancelled', label, hint: 'The delivery partner cancelled this allocation, so the order went back to Pending.' };
    }
    if (lower.includes('reassign')) {
      return { kind: 'reassign', label, hint: 'The order was reassigned and went back to Pending for a new rider.' };
    }
    return { kind: 'info', label, hint: 'The order went back to Pending.' };
  }

  private async refreshTrackingRoutes(riderLatLng: Leaflet.LatLng) {
    // Blue — the planned pickup -> delivery route (kept in sync in case the coordinates changed;
    // it's also drawn independently of rider tracking by addOrderMarkers()).
    await this.ensurePickupToDeliveryRoute();

    // Orange — rider -> pickup, only relevant before the rider has reached pickup.
    const statusId = this.orderData?.order_status_id;
    const prePickup = [constant.OrderStatusId.assigned, constant.OrderStatusId.arrivedAtPickup].includes(statusId);
    if (prePickup) {
      await this.refreshAssignToPickupRoute(riderLatLng);
    } else {
      this.clearAssignToPickupRoute();
    }

    // Green — the rider's live GPS trail, always kept in sync with every ping received so far.
    this.riderLiveRouteCoordinates = this.getRiderGpsTrail();
    this.renderRiderLiveLayer();
  }

  // ==================== Playback: replay of the recorded GPS history ====================

  // Rebuilds the playback timeline whenever fresh loc-track data arrives. Doesn't touch the
  // live marker/routes — playback only takes over the marker while actively playing.
  preparePlayback() {
    this.riderTrackPoints = this.getRiderTrackHistory();
    this.riderPlaybackReady = this.riderTrackPoints.length > 1;
    if (!this.riderPlaybackReady) return;

    this.riderPlaybackTStart = this.riderTrackPoints[0].t;
    this.riderPlaybackTEnd = this.riderTrackPoints[this.riderTrackPoints.length - 1].t;
    this.riderPlaybackStartLabel = moment(this.riderPlaybackTStart).format('hh:mm:ss A');
    this.riderPlaybackEndLabel = moment(this.riderPlaybackTEnd).format('hh:mm:ss A');
    if (!this.isRiderPlaying && this.riderPlaybackProgress === 0) {
      this.riderPlaybackCurrentT = this.riderPlaybackTStart;
      this.riderPlaybackCurrentLabel = this.riderPlaybackStartLabel;
    }
  }

  toggleRiderPlayback(): void {
    if (this.isRiderPlaying) {
      this.pauseRiderPlayback();
    } else {
      this.playRiderPlayback();
    }
  }

  /**
   * Play button handler.
   *
   * A wrapper, not a replacement: `toggleRiderPlayback()` above is untouched and
   * is still the only thing that starts or stops a replay. This adds the two
   * things a replay wants around it — the map at full size, and a beat to take
   * it in before the marker starts moving.
   *
   * Only *starting* counts down. Pausing is an interruption and has to land the
   * moment it is pressed, and a second press during the count means "never
   * mind" rather than "start sooner".
   */
  onPlayButtonClick(): void {
    if (this.playCountdown !== null) {
      this.cancelPlayCountdown();
      return;
    }

    if (this.isRiderPlaying) {
      this.toggleRiderPlayback();
      return;
    }

    if (!this.isMapExpanded) {
      this.toggleMapExpand();
    }
    this.startPlayCountdown();
  }

  private startPlayCountdown(): void {
    this.cancelPlayCountdown();
    this.playCountdown = 3;
    this.playCountdownTimer = setInterval(() => {
      if (this.playCountdown === null) return;
      this.playCountdown--;
      // 3, 2, 1 each hold for a second; zero is never shown — it is the cue.
      if (this.playCountdown > 0) return;
      this.cancelPlayCountdown();
      this.toggleRiderPlayback();
    }, 1000);
  }

  private cancelPlayCountdown(): void {
    if (this.playCountdownTimer) {
      clearInterval(this.playCountdownTimer);
      this.playCountdownTimer = null;
    }
    this.playCountdown = null;
  }

  playRiderPlayback(): void {
    if (!this.riderPlaybackReady || !this.riderMarker) return;
    // A run that already finished (or a scrubber dragged to the very end) leaves currentT at/past
    // tEnd — always rewind to the rider's first recorded point before starting, otherwise this
    // frame would immediately look "finished" and the icon would never appear to move.
    if (this.riderPlaybackCurrentT >= this.riderPlaybackTEnd) {
      this.riderPlaybackCurrentT = this.riderPlaybackTStart;
    }
    this.isRiderPlaying = true;
    this.riderPlaybackLastFrame = performance.now();

    const step = (now: number) => {
      if (!this.isRiderPlaying) return;
      const dtReal = now - this.riderPlaybackLastFrame;
      this.riderPlaybackLastFrame = now;
      const span = Math.max(this.riderPlaybackTEnd - this.riderPlaybackTStart, 1);
      this.riderPlaybackCurrentT += dtReal * (span / this.RIDER_REPLAY_BASE_MS) * this.riderPlaybackSpeed;
      this.applyPlaybackFrame(this.riderPlaybackCurrentT);

      if (this.riderPlaybackCurrentT >= this.riderPlaybackTEnd) {
        this.isRiderPlaying = false;
        // Hand back control to live GPS tracking at its real current position...
        if (this.riderLocation) this.riderMarker.setLatLng([this.riderLocation.lat, this.riderLocation.lng]);
        // ...but reset the scrubber back to the rider's starting point, so the next Play press
        // replays the whole trip from the beginning instead of doing nothing (currentT was left
        // at tEnd, which looks instantly "finished" the moment playback starts).
        this.riderPlaybackCurrentT = this.riderPlaybackTStart;
        this.riderPlaybackProgress = 0;
        this.riderPlaybackCurrentLabel = this.riderPlaybackStartLabel;
        return;
      }
      this.riderPlaybackRafId = requestAnimationFrame(step);
    };
    this.riderPlaybackRafId = requestAnimationFrame(step);
  }

  pauseRiderPlayback(): void {
    this.isRiderPlaying = false;
    if (this.riderPlaybackRafId) {
      cancelAnimationFrame(this.riderPlaybackRafId);
      this.riderPlaybackRafId = null;
    }
  }

  resetRiderPlayback(): void {
    this.pauseRiderPlayback();
    this.riderPlaybackCurrentT = this.riderPlaybackTStart;
    this.applyPlaybackFrame(this.riderPlaybackCurrentT);
  }

  // Scrubber drag handler — seeks to a 0..100 position along the timeline without auto-playing.
  seekRiderPlayback(progressPercent: number): void {
    if (!this.riderPlaybackReady) return;
    this.pauseRiderPlayback();
    const span = Math.max(this.riderPlaybackTEnd - this.riderPlaybackTStart, 1);
    this.riderPlaybackCurrentT = this.riderPlaybackTStart + (progressPercent / 100) * span;
    this.applyPlaybackFrame(this.riderPlaybackCurrentT);
  }

  toggleRiderPlaybackSpeedMenu(): void {
    this.riderPlaybackSpeedMenuOpen = !this.riderPlaybackSpeedMenuOpen;
  }

  setRiderPlaybackSpeed(speed: number): void {
    this.riderPlaybackSpeed = speed;
    this.riderPlaybackSpeedMenuOpen = false;
  }

  // Recenters the map on the rider's current marker position (the "follow" button).
  recenterOnRider(): void {
    if (!this.map || !this.riderMarker) return;
    this.map.panTo(this.riderMarker.getLatLng(), { animate: true });
  }

  // Scrubber slider (input) handler — plain DOM event, no FormsModule needed.
  onPlaybackSeek(event: Event): void {
    const value = Number((event.target as HTMLInputElement).value);
    this.seekRiderPlayback(value);
  }

  // Top-right "Reset" button — explicitly refits the map to the current routes (Section 20:
  // never done automatically per GPS tick, only on this kind of deliberate user action).
  resetMapView(): void {
    this.fitAllRoutes();
  }

  // Moves the marker to time `t` on the recorded track (interpolating between the two nearest
  // points), updates the scrubber progress/labels, and flags idle when the rider barely moved
  // between those two points.
  private applyPlaybackFrame(t: number): void {
    const pts = this.riderTrackPoints;
    if (pts.length < 2) return;
    const clampedT = Math.max(this.riderPlaybackTStart, Math.min(t, this.riderPlaybackTEnd));

    let i = 0;
    while (i < pts.length - 2 && pts[i + 1].t < clampedT) i++;
    const a = pts[i], b = pts[Math.min(i + 1, pts.length - 1)];
    const segSpan = Math.max(b.t - a.t, 1);
    const segFrac = Math.min(Math.max((clampedT - a.t) / segSpan, 0), 1);
    const lat = a.lat + (b.lat - a.lat) * segFrac;
    const lng = a.lng + (b.lng - a.lng) * segFrac;
    this.riderMarker.setLatLng([lat, lng]);

    const span = Math.max(this.riderPlaybackTEnd - this.riderPlaybackTStart, 1);
    this.riderPlaybackProgress = ((clampedT - this.riderPlaybackTStart) / span) * 100;
    this.riderPlaybackCurrentLabel = moment(clampedT).format('hh:mm:ss A');

    // Idle if the rider covered under ~5m across this segment despite a real time gap.
    const segMeters = Leaflet.latLng(a.lat, a.lng).distanceTo(Leaflet.latLng(b.lat, b.lng));
    this.riderPlaybackIsIdle = segMeters < 5 && segSpan > 30000;

    // Same heading rotation + time/idle badge the live marker gets, driven by the replay clock.
    this.applyRiderHeading(this.bearingBetween(a, b));
    this.updateRiderMarkerBadge(clampedT, this.riderPlaybackIsIdle);
  }

  issueCheck() {
    this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.IssueCommentGetById, { order_id: this.orderId }).subscribe((response: any) => {
      if (response.status) { this.dataNullCheck = response.data == null ? true : false; }
    });
  }
  commonFunction(data: any) {
    if (!_.isEmpty(data?.OrderDetail?.delivery_partner_rider_dtl)) {
      this.trackorderDetails.DeliveryStaff = {
        full_name: data?.OrderDetail?.delivery_partner_rider_dtl?.full_name,
        phone: data?.OrderDetail?.delivery_partner_rider_dtl?.phone,
        DsCurrentLocation: {
          lat: data?.ds_current_lat ?? (data?.OrderDetail?.delivery_partner_rider_dtl?.DsCurrentLocation?.lat),
          long: data?.ds_current_long ?? (data?.OrderDetail?.delivery_partner_rider_dtl?.DsCurrentLocation?.long)
        }
      }
      if (this.trackorderDetails?.DeliveryStaff) {
        if (data?.DeliveryStaff?.dp_url) {
          let newDate = moment().format('x');
          this.trackorderDetails.DeliveryStaff.dp_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + data?.DeliveryStaff?.dp_url + '&=' + newDate
        } else {
          this.trackorderDetails.DeliveryStaff.dp_url = 'assets/images/ad_bike.png';
        }
      } else {
        // this.dsDetailsShow = true;
        this.trackorderDetails.DeliveryStaff.dp_url = 'assets/images/ad_bike.png';
        // this.trackorderDetails.DeliveryStaff = {
        //   dp_url: 'assets/images/user/ad_bike.png'
        // }
      }
    } else {
      this.trackorderDetails.DeliveryStaff = {
        full_name: data?.DeliveryStaff?.full_name,
        phone: data?.DeliveryStaff?.phone,
        DsCurrentLocation: {
          lat: data?.ds_current_lat ?? (data?.DeliveryStaff?.DsCurrentLocation?.lat),
          long: data?.ds_current_long ?? (data?.DeliveryStaff?.DsCurrentLocation?.long)
        }
      }
      if (this.trackorderDetails?.DeliveryStaff) {
        if (data?.DeliveryStaff?.dp_url) {
          let newDate = moment().format('x');
          this.trackorderDetails.DeliveryStaff.dp_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + data?.DeliveryStaff?.dp_url + '&=' + newDate
        } else {
          this.trackorderDetails.DeliveryStaff.dp_url = 'assets/images/ad_bike.png';
        }
      } else {
        // this.dsDetailsShow = true;
        this.trackorderDetails.DeliveryStaff.dp_url = 'assets/images/ad_bike.png';
        // this.trackorderDetails.DeliveryStaff = {
        //   dp_url: 'assets/images/user/ad_bike.png'
        // }
      }

    }
    if (!this.riderCurrentLocationMarker) {
      // One icon, one path. This used to branch on `location.origin` containing
      // "child" and hand the other case a hard-coded '/app/assets/…', which only
      // resolves where the app is served from an /app/ sub-path — index.html
      // declares `<base href="/">` and nothing sets deployUrl, so on every other
      // host the marker rendered as a broken image.
      //
      // Both branches were the same artwork at the same size anyway, so the
      // shared constant covers both deployments and there is now a single place
      // to change it.
      this.riderCurrentLocationMarker = Leaflet.marker([Number(this.trackorderDetails?.DeliveryStaff?.DsCurrentLocation?.lat || 0), Number(this.trackorderDetails?.DeliveryStaff?.DsCurrentLocation?.long || 0)], {
        icon: constant.mapIcons.riderBike
      }).addTo(this.map);
    }
    else {
      this.riderCurrentLocationMarker?.setLatLng([Number(this.trackorderDetails?.DeliveryStaff?.DsCurrentLocation?.lat || 0), Number(this.trackorderDetails?.DeliveryStaff?.DsCurrentLocation?.long || 0)]);
    }
  }

  /**
   * Takes the loader down in two stages instead of one, so it always leaves
   * the same way regardless of how fast the response was:
   *
   *   1. hold, if the data beat LOADER_MIN_MS — a loader that flashes for
   *      80ms and vanishes looks like a glitch, so it serves out the rest of
   *      that window first;
   *   2. fade, by flipping `.is-leaving` and only unmounting once the CSS
   *      animation has actually finished. `@if` removes the node the instant
   *      the flag drops, so without this step there is no exit at all — the
   *      loader simply blinks out from full opacity.
   *
   * Idempotent: called from three different outcomes in getOrderDetails()
   * plus the no-id path, and the 10s poll keeps calling the first of those.
   */
  private finishOrderLoading(): void {
    if (!this.isOrderLoading || this.isOrderLoaderLeaving) return;

    const shown = Date.now() - this.orderLoaderStartedAt;
    const hold = Math.max(0, OrderDetailViewComponent.LOADER_MIN_MS - shown);

    this.orderLoaderHoldTimer = setTimeout(() => {
      this.isOrderLoaderLeaving = true;
      this.orderLoaderExitTimer = setTimeout(
        () => {
          this.isOrderLoading = false;
          this.isOrderLoaderLeaving = false;
        },
        OrderDetailViewComponent.LOADER_EXIT_MS
      );
    }, hold);
  }

  getOrderDetails() {
    var url = constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.GetById + this.orderId;
    if (this.reqfor == 'history') {
      url += '?reqOrder=History'
    }
    this.http.get(url, {}).subscribe((response: any) => {
      // Run on every outcome, including the error arm below — otherwise a
      // failed first fetch would leave the loader spinning forever.
      this.finishOrderLoading();
      if (response && !_.isNull(response.data)) {
        this.orderUUid = response.data.order_uuid;
        this.orderProcessing(response.data);
      } else {
        this.toaster.error('Order details not found');
        this.orderNotFound = true;
      }
    }, (error) => {
      this.finishOrderLoading();
      console.error('Error fetching order details:', error);
    });
  }
  getProviderName(allocation: any): string {
    if (allocation?.DeliveryStaff) {
      return 'EK-Bharat';
    }

    if (allocation?.DeliveryPartner) {
      const platform = (this.riderPlatformName || '').toLowerCase();
      const partner = (allocation?.DeliveryPartner?.full_name || '').toLowerCase();

      if (platform.includes(partner)) {
        return this.riderPlatformName;
      }

      return allocation?.DeliveryPartner?.full_name;
    }

    return '';
  }

  // Per-entry status for a 3PL allocation attempt (Cancelled / Pending / the order's current status),
  // mirroring the logic used for the DP allocation badge on the live-orders page.
  // One-line sentence for a 3PL-panel row: "<Provider> <text>", with an icon
  // and tone. Attempt rows (ctd_dt set) read the API message / allocation
  // status; status rows read order_status_id. Tone: '' follows the row's
  // status colour, 'danger' / 'warn' / 'muted' / 'brand' override it.
  // Messages are free text from the partner APIs, so they're classified by
  // keyword; anything unrecognised is shown as-is with an info icon.
  getAllocationNote(allocation: any, isAttempt: boolean): AllocationNote | null {
    if (!allocation) return null;
    const name = this.getProviderName(allocation) || allocation?.DeliveryPartner?.full_name || '';
    const note = (icon: AllocationNote['icon'], text: string, tone: AllocationNote['tone'] = '', raw = false): AllocationNote =>
      ({ icon, text, tone, name, raw });
    // Cancelled rows show just the label, without the provider name.
    const cancelled: AllocationNote = { icon: 'cancelled', text: 'Cancelled', tone: 'danger', name: '', raw: false };

    if (isAttempt) {
      const message: string = (allocation?.message || '').trim();
      if (message) {
        const m = message.toLowerCase();
        if (m.includes('servic')) return note('not-serviceable', 'cannot deliver to this location', 'danger');
        if (/(rider|driver|partner|agent|runner)/.test(m) && /(not|no |unavailable|busy)/.test(m)) {
          return note('no-rider', 'has no rider available right now', 'warn');
        }
        if (m.includes('cancel')) return cancelled;
        return note('info', message, 'muted', true);
      }
      const status = this.getAllocationStatus(allocation).text;
      if (status === 'Cancelled') return cancelled;
      if (status === 'Pending') return note('pending', 'is looking for a rider', 'warn');
      if (allocation?.partner_uniq_order_id) return note('assigned', 'received the delivery request', 'brand');
      return null;
    }

    switch (Number(allocation?.order_status_id)) {
      case constant.OrderStatusId.pending: return note('pending', 'released the order, back to Pending', 'warn');
      case constant.OrderStatusId.assigned: return note('assigned', 'has been assigned this order');
      case constant.OrderStatusId.arrivedAtPickup: return note('arrived', 'rider has arrived at the pickup point');
      case constant.OrderStatusId.pickedUp: return note('picked-up', 'rider has picked up the order');
      case constant.OrderStatusId.outForDelivery: return note('transit', 'rider is out for delivery');
      case constant.OrderStatusId.arrived:
      case 23: return note('arrived', 'rider has arrived at the drop location');
      case constant.OrderStatusId.delivered: return note('delivered', 'delivered the order');
      case constant.OrderStatusId.cancelled: return cancelled;
      case constant.OrderStatusId.undelivered: return note('not-serviceable', 'could not deliver the order', 'danger');
      case constant.OrderStatusId.return: return note('return', 'rider is returning the order');
      case constant.OrderStatusId.RTODelivered: return note('delivered', 'returned the order to the sender');
      default: return null;
    }
  }

  getAllocationStatus(allocation: any): { text: string; cssClass: string } {
    if (!allocation) {
      return { text: '', cssClass: '' };
    }
    if (this.reqfor != 'history') {

      if (allocation.partner_user_id != constant.adloggs_third_party_partner_id) {
        if (allocation?.cancelled) {
          return { text: 'Cancelled', cssClass: 'status-cancelled' };
        }

        // if (this.orderData?.delivery_partner_user_id == allocation.partner_user_id) {
        //   return { text: this.orderData?.OrderStatus?.order_status_name || '', cssClass: 'status-assigned' };
        //  }
        return { text: '', cssClass: '' };
      } else if (!this.orderData?.DeliveryStaff?.delivery_staff_id) {
        const isPending = [1, 2].includes(this.orderData?.order_status_id);
        return isPending ? { text: 'Pending', cssClass: 'status-pending' } : { text: 'Cancelled', cssClass: 'status-cancelled' };
      } else {
        return { text: '', cssClass: '' };
      }
    } else {
      // History entries carry their own final order_status_id per allocation attempt,
      // so it's read directly instead of cross-referencing this.orderData.
      if (allocation?.order_status_id == constant.OrderStatusId.cancelled && !allocation?.message) {
        return { text: 'Cancelled', cssClass: 'status-cancelled' };
      }
      // if ([constant.OrderStatusId.delivered, constant.OrderStatusId.RTODelivered, constant.OrderStatusId.systemFinished].includes(allocation?.order_status_id)) {
      //   return { text: this.constant.OrderStatusName[allocation?.order_status_id] || '', cssClass: 'status-assigned' };
      // }
      return { text: '', cssClass: '' };
    }
  }

  // Restarts the 1s .ad-od-status-flash CSS animation even if a flash from a
  // previous status change is still finishing: drop the class, let Angular
  // render that with a 0ms setTimeout (a bare re-set to true would no-op if
  // it were already true), then re-add it for exactly 1s.
  private flashStatusChange(): void {
    clearTimeout(this.statusFlashTimer);
    this.showStatusFlash = false;
    setTimeout(() => {
      this.showStatusFlash = true;
      this.statusFlashTimer = setTimeout(() => {
        this.showStatusFlash = false;
      }, 1000);
    });
  }

  /**
   * Starts, restarts or stops the status typewriter for the current status.
   *
   * On a live order the heading retypes itself on a 5s loop, so the line keeps
   * reading as something actively being worked out rather than animating once
   * on arrival and then sitting still for the rest of the delivery.
   *
   * Called from orderProcessing(), so this runs on every 10s poll. Two guards
   * matter because of that: a finished order tears the loop down (an order can
   * go live -> delivered while the page is open), and an unchanged status with
   * a loop already running is left alone rather than restarted — otherwise
   * every poll would reset the 5s phase and the replay would drift with the
   * polling cadence instead of keeping its own beat.
   *
   * Finished orders, an empty status, or a reduced-motion preference all skip
   * straight to the full text -- the heading must always end up readable, the
   * animation is decoration on top of it.
   */
  private runStatusTypewriter(next: string): void {
    const text = next || '';
    const changed = text !== this.statusTypeTarget;
    this.statusTypeTarget = text;

    if (!text || !this.isOrderLive || this.prefersReducedMotion()) {
      this.stopStatusTypewriter();
      this.statusTyped = text;
      this.isStatusTyping = false;
      return;
    }

    // Same text, loop already beating -- let it keep its phase.
    if (!changed && this.statusCycleTimer) return;

    this.stopStatusTypewriter();
    this.typeStatusOnce(text);
    this.statusCycleTimer = setInterval(
      () => this.typeStatusOnce(text),
      OrderDetailViewComponent.STATUS_REPEAT_MS
    );
  }

  /** One pass of the reveal. Longest label is well under the 5s repeat. */
  private typeStatusOnce(text: string): void {
    clearInterval(this.statusTypeTimer);
    this.statusTyped = '';
    this.isStatusTyping = true;
    let i = 0;
    this.statusTypeTimer = setInterval(() => {
      this.statusTyped = text.slice(0, ++i);
      if (i >= text.length) {
        clearInterval(this.statusTypeTimer);
        this.statusTypeTimer = null;
        this.isStatusTyping = false;
      }
    }, OrderDetailViewComponent.STATUS_TYPE_MS);
  }

  /** Both timers go together — a stray cycle timer would revive the reveal. */
  private stopStatusTypewriter(): void {
    clearInterval(this.statusTypeTimer);
    clearInterval(this.statusCycleTimer);
    this.statusTypeTimer = null;
    this.statusCycleTimer = null;
  }

  /** Honoured by every motion cue on this page, not just the typewriter. */
  private prefersReducedMotion(): boolean {
    return typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /**
   * Stamps a stable `__rowKey` on every row of a polled list.
   *
   * getOrderDetails() re-runs every 10s and reassigns these arrays with freshly
   * parsed objects, so a template tracking by object identity (`track flow`)
   * never matches and Angular destroys and rebuilds every row on every poll —
   * a visible tear four times a minute, and the reason a status change landed
   * as a jump rather than a change. Keying on content instead lets unchanged
   * rows keep their DOM, so only what actually changed re-renders.
   *
   * Keys are deduped because `@for` treats a repeated key as a hard error
   * (NG0955), which would be a worse outcome than the re-render this avoids.
   * The suffix is deterministic for a stable ordering, so a collided row still
   * keeps the same key across polls.
   */
  private stampRowKeys(rows: any[], keyOf: (row: any) => string): any[] {
    const seen = new Set<string>();
    for (const row of rows || []) {
      if (!row || typeof row !== 'object') continue;
      let key = keyOf(row);
      while (seen.has(key)) key += '+';
      seen.add(key);
      row.__rowKey = key;
    }
    return rows;
  }

  /**
   * Runs the Order Status card's cover for one transition.
   *
   * Restartable: a second status change while the first cover is still up
   * resets it rather than queueing a second teardown, which would otherwise
   * unmount the cover mid-way through the newer transition.
   */
  private runStatusLoader(): void {
    clearTimeout(this.statusLoaderHoldTimer);
    clearTimeout(this.statusLoaderExitTimer);
    this.isStatusUpdating = true;
    this.isStatusLoaderLeaving = false;

    this.statusLoaderHoldTimer = setTimeout(() => {
      // Two stages, same as finishOrderLoading: flip the exit class, keep the
      // node mounted for exactly the length of that animation, then unmount.
      // Dropping it straight from @if would blink it out at full opacity.
      this.isStatusLoaderLeaving = true;
      this.statusLoaderExitTimer = setTimeout(
        () => {
          this.isStatusUpdating = false;
          this.isStatusLoaderLeaving = false;
        },
        OrderDetailViewComponent.LOADER_EXIT_MS
      );
    }, OrderDetailViewComponent.STATUS_LOADER_MS);
  }

  orderProcessing(orderData: any) {
    this.orderData = orderData || {};

    // `getOrderDetails` resolves after the setTimeout that first calls
    // `initControlxActivity`, so it's repeated here too — a no-op once the
    // feed has already started.
    this.initControlxActivity();

    // Status-change background flash: only once there is a previous value to
    // compare against, so the first load is silent and only a genuine
    // transition (e.g. Assigned -> Arrived at Pickup) on a later refresh
    // triggers the cue. See flashStatusChange() and .ad-od-status-flash.
    const newStatusId = this.orderData?.order_status_id;
    if (this.previousOrderStatusId !== null && this.previousOrderStatusId !== newStatusId) {
      this.flashStatusChange();
      // Never stack on the first-load cover: it is already covering this card,
      // and a second one underneath would flash as that one dissolves.
      if (!this.isOrderLoading) this.runStatusLoader();
    }
    this.previousOrderStatusId = newStatusId;

    this.deliveryPartner = orderData.DeliveryPartner || {};
    if (this.reqfor == 'history') {
      this.orderflows = orderData.OrderFlowDumps || [];
    } else {
      this.orderflows = orderData.OrderFlows || [];
    }
    // A status happens once at a given moment, so status + timestamp is the
    // row's identity across polls. See stampRowKeys.
    this.stampRowKeys(this.orderflows, row =>
      `${row?.order_status_id ?? ''}|${row?.date_time ?? row?.ctd_dt ?? ''}`);
    this.orderflowsDesc = [...this.orderflows].reverse();
    this.manualAssignedCheck = this.orderflows.some((x: any) => x.user_id != null && x.delivery_staff_id != null);
    // this.orderflows = this.orderflows.reverse();
    var lastStatusDate = '';
    if (this.orderflows.length > 0) {
      lastStatusDate = this.orderflows[this.orderflows.length - 1]?.date_time;
    } else {
      lastStatusDate = this.orderData?.ctd_dt;
    }
    if (this.orderData?.ctd_dt) {
      this.orderData.ctd_short_date = this.orderDateFormat(this.orderData?.ctd_dt, constant.dateTimeFullFormat);
    }
    if (this.orderData?.CancelledBy) {
      this.cancelledBy = this.orderData?.CancelledBy;
      this.cancelledBy.desc = this.orderData?.order_cancel_description || '--';
      this.cancelledBy.date = (this.orderData?.cancelled_date_time) ? this.orderDateFormatChange(this.orderData?.cancelled_date_time, constant.datePickerFormat) : '';
    } else {
      this.cancelledBy = {};
    }

    let delivery_img = this.reqfor == 'history' ? this.orderData?.proof_of_delivery : this.orderData?.OrderDetail.proof_of_delivery
    let pickup_img = this.reqfor == 'history' ? this.orderData?.proof_of_pickup : this.orderData?.OrderDetail.proof_of_pickup
    let delivery_collection_img = this.reqfor == 'history' ? this.orderData?.proof_of_delivery_collection : this.orderData?.OrderDetail.proof_of_delivery_collection
    let rto_delivered_img = this.reqfor == 'history' ? this.orderData?.proof_of_rto_delivered : this.orderData?.OrderDetail.proof_of_rto_delivered

    if (delivery_img != "" && delivery_img != null) this.proof_of_delivery = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + delivery_img;
    if (pickup_img != "" && pickup_img != null) this.proof_of_pickup = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + pickup_img;
    if (delivery_collection_img != "" && delivery_collection_img != null) this.proof_of_delivery_collection = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + delivery_collection_img;
    if (rto_delivered_img != "" && rto_delivered_img != null) this.proof_of_rto_delivered = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + rto_delivered_img;

    this.lastStatus = {
      status: this.constant.OrderStatusName[this.orderData?.order_status_id] || '',
      riderName: (orderData.DeliveryStaff) ? "EK-Bharat" : this.deliveryPartner?.full_name || '',
      time: (lastStatusDate) ? this.orderDateFormat(lastStatusDate, constant.timeFromatHtmlWithSec) : '',
      date: (lastStatusDate) ? this.orderDateFormat(lastStatusDate, constant.dateFormat) : '',
      timeRemaining: orderData?.total_time_in_text || '',
      distanceRemaining: orderData?.total_distance_in_text || ''
    };
    // Reads `lastStatus.status`, so it has to come after the literal above.
    // No-ops unless the string actually changed -- see runStatusTypewriter.
    this.runStatusTypewriter(this.lastStatus.status);
    if (this.orderData?.OrderDetail?.rider_platform_name) {
      this.lastStatus.riderName += '_' + this.orderData?.OrderDetail?.rider_platform_name;
    } else if (this.orderData?.rider_platform_name && this.orderData?.rider_platform_name != null) {
      this.lastStatus.riderName += '_' + this.orderData?.rider_platform_name;
    }
    if (this.thirdPartyAllocation) {
      var status = this.thirdPartyAllocation[0];
      this.lastStatus.iconUrl = (status?.DeliveryPartner?.icon_url) ? status?.DeliveryPartner?.icon_url : "assets/images/avatar/3pl/ek-bharat.png";
    }
    this.stampFlowRiderIcons();
    if (this.orderData?.actual_assigned_date_time != null) {
      if (orderData.DeliveryPartner) {
        this.deliveryStaff = orderData.OrderDetail?.delivery_partner_rider_dtl || {};
      } else {
        this.deliveryStaff = orderData.DeliveryStaff || {};
      }
      if (!this.hasObjectKeys(this.deliveryStaff)) {
        this.deliveryStaff = {
          full_name: orderData?.rider_name,
          phone: orderData?.rider_phone,
        }
      }
      if (this.deliveryStaff.dp_url) {
        this.deliveryStaff.dp_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + this.deliveryStaff.dp_url
      };
      if (this.deliveryStaff) {
        this.deliveryStaff.delivery_partner_name = this.lastStatus.riderName || '';
        this.deliveryStaff.delivery_partner_icon_url = this.lastStatus.iconUrl || '';
        this.riderPlatformName = this.lastStatus.riderName || '';
        // DeliveryStaff.UnderAgency only exists for our own fleet; a 3PL order
        // (Rapido, etc.) populates deliveryStaff from delivery_partner_rider_dtl
        // instead, so this also checks the same UnderAgency shape there.
        this.deliveryStaff.agencyName = this.orderData?.DeliveryStaff?.UnderAgency?.full_name
          || this.orderData?.OrderDetail?.delivery_partner_rider_dtl?.UnderAgency?.full_name
      }
    } else {
      this.deliveryStaff = {};
    }
    this.addOrderMarkers();
    this.getBlockRiderReason();
  }


  getKm(flow: any) {
    if ([constant.OrderStatusId.arrived, constant.OrderStatusId.outForDelivery, constant.OrderStatusId.delivered, constant.OrderStatusId.RTODelivered, constant.OrderStatusId.return].includes(flow.order_status_id)) {
      // Consider 0, 0.0, 00.00000, '0', '0.0', '00.00000', undefined, null, '', etc. as falsy or invalid coordinates
      const lat = (typeof flow.lat === 'string') ? parseFloat(flow.lat) : flow.lat;
      const long = (typeof flow.long === 'string') ? parseFloat(flow.long) : flow.long;
      if (
        (!lat && !long) ||
        (lat === 0 && long === 0) ||
        (isNaN(lat) && isNaN(long)) ||
        (lat === undefined && long === undefined) ||
        (lat === null && long === null)
      ) {
        return '';
      } else {
        let reqObj: any = {
          lat1: flow.lat,
          long1: flow.long,
          lat2: this.orderData?.delivery_lat,
          long2: this.orderData?.delivery_long
        }
        let km = commonLogics.latLongToCalculateDistanceViaHaversineFormula(reqObj);
        return `${km.toFixed(2)} Km`;
      }
    } else if ([constant.OrderStatusId.assigned, constant.OrderStatusId.arrivedAtPickup, constant.OrderStatusId.pickedUp].includes(flow.order_status_id)) {
      let reqObj: any = {
        lat1: flow.lat,
        long1: flow.long,
        lat2: this.orderData?.pickup_lat,
        long2: this.orderData?.pickup_long
      }
      let km = commonLogics.latLongToCalculateDistanceViaHaversineFormula(reqObj);

      return `${km.toFixed(2)} Km`;
    }
  }
  googleMapLink(flow: any) {
    if ([constant.OrderStatusId.arrived, constant.OrderStatusId.outForDelivery, constant.OrderStatusId.delivered, constant.OrderStatusId.RTODelivered, constant.OrderStatusId.return].includes(flow.order_status_id)) {
      if (flow?.lat && flow?.long && this.orderData?.delivery_lat && this.orderData?.delivery_long) {
        let url = `https://www.google.com/maps/dir/${flow.lat},${flow.long}/${this.orderData?.delivery_lat},${this.orderData?.delivery_long}`
        window.open(url);
      }
    } else if ([constant.OrderStatusId.assigned, constant.OrderStatusId.arrivedAtPickup, constant.OrderStatusId.pickedUp].includes(flow.order_status_id)) {
      if (flow?.lat && flow?.long && this.orderData?.pickup_lat && this.orderData?.pickup_long) {
        let url = `https://www.google.com/maps/dir/${flow.lat},${flow.long}/${this.orderData?.pickup_lat},${this.orderData?.pickup_long}`
        window.open(url);
      }
    }
  }

  getDeliveryPartnerDetails() {
    var url = constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.RCAThirdPartyAllocation + this.orderId;
    if (this.reqfor == 'history') {
      url += '?reqOrder=History'
    }
    this.http.get(url, {}).subscribe((response: any) => {
      if (response.data) {
        this.dpData = response.data;
        response.data.integratedresponse.forEach((iteam: any,) => {
          if (this.reqfor == 'history') {
            iteam.date_time = iteam?.activity_date_time;
            iteam.partner_uniq_order_id = iteam?.dp_uniq_order_id
          } else {
            if (iteam?.ctd_dt) {
              iteam.date_time = iteam.ctd_dt;
            }
          }
          if (iteam?.DeliveryPartner?.icon_url) {
            iteam.DeliveryPartner.icon_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + iteam?.DeliveryPartner?.icon_url
          }
        });
        response.data.orderFlow.forEach((iteam: any,) => {
          if (iteam?.DeliveryPartner?.icon_url) {
            iteam.DeliveryPartner.icon_url = constant.ImageUrl.BaseUrl + constant.ImageUrl.Adloggs.ShowImage + iteam?.DeliveryPartner?.icon_url;
          }
        });
        this.thirdPartyAllocation = [
          ...(response.data.orderFlow || []),
          ...(response.data.integratedresponse || [])
        ];
        this.thirdPartyAllocation = (this.thirdPartyAllocation || []).sort((a: any, b: any) => {
          const dateA = new Date(a.date_time || 0).getTime();
          const dateB = new Date(b.date_time || 0).getTime();
          return dateB - dateA;
        });
        // Content-derived, not index-derived: this list is sorted newest-first,
        // so a new attempt lands at index 0 and shifts every other row.
        this.stampRowKeys(this.thirdPartyAllocation, row =>
          `${row?.order_status_id ?? ''}|${row?.date_time ?? row?.ctd_dt ?? ''}|${row?.partner_uniq_order_id ?? ''}`);
        this.thirdPartyAllocation.forEach((item: any, index: number) => {
          // Show the time difference to the next entry (index + 1)
          if (index < this.thirdPartyAllocation.length - 1) {
            item.timeDifference = this.calculateTimeDifference(index + 1);
          } else {
            // For the last entry, show empty or calculate from current time
            item.timeDifference = '';
          }
        });
        var status = this.thirdPartyAllocation[0];
        this.lastStatus.iconUrl = (status?.DeliveryPartner?.icon_url) ? status?.DeliveryPartner?.icon_url : "assets/images/avatar/3pl/ek-bharat.png";
        this.stampFlowRiderIcons();
      }
    });
  }

  // getSwiggyTickets() {
  //   let req = {
  //     order_id: this.orderId
  //   }
  //   let Url = constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Support.getComment;
  //   this.http.postData(Url, req).subscribe((response: any) => {
  //      if (response?.data?.length > 0) {
  //          this.swiggyTickets = response.data.reverse();
  //          for (let i = 0; i < this.swiggyTickets.length; i++) {
  //             this.swiggyTickets[i].ctd_dt_ist = this.convertUtctoIST(this.swiggyTickets[i].ctd_dt);
  //          if (!this.swiggyTickets[i].order_flow_comment) {
  //            this.swiggyTickets[i].order_flow_comment = 'Audio Message';
  //          }
  //        }
  //      } else {
  //          this.swiggyTickets = [];
  //        }
  //   });
  // }
  getSwiggyTickets() {
    let Url = constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Support.getComment;
    this.http.postData(Url, { order_id: this.orderId }).subscribe((response: any) => {
      const supportData = response?.data?.SupportTicket || [];
      const riderData = response?.data?.RiderSupport || [];
      this.supportTicket = supportData.length ? this.processSupportData(supportData) : [];
      this.riderSupport = riderData.length ? this.processSupportData(riderData) : [];
    }, error => {
      console.error('Error fetching support tickets:', error);
    });
  }

  // SupportTicket and RiderSupport data
  processSupportData(data: any[]) {
    return [...data].reverse().map(item => {
      item.ctd_dt_ist = this.convertUtctoIST(item.ctd_dt);

      // SupportTicket case
      if ('order_flow_comment' in item && !item.order_flow_comment) {
        item.order_flow_comment = 'Audio Message';
      }

      // RiderSupport case
      if ('message' in item && !item.message) {
        item.message = 'Audio Message';
      }
      return item;
    });
  }
  convertUtctoIST(date: any) {
    let dateData = moment.utc(date, constant.DateFormatServerSideWithDateTime).local().format(constant.timeFromatHtmlWithSec + ' | ' + constant.dateFormat);
    return dateData;
  }

  orderDateFormat(datetime: any, format: string) {
    if (datetime) {
      return moment.utc(datetime, constant.DateFormatServerSideWithDateTimeWithSec).local().format(format);
    } else {
      return '--';
    }
  }
  orderDateFormatChange(datetime: any, format: string) {

    if (datetime) {
      return moment(datetime, constant.DateFormatServerSideWithDateTimeWithSec).format(format);
    } else {
      return '--';
    }
  }

  initializeMap() {
    // Initialize the map
    this.map = Leaflet.map('orderDetailMap', {
      zoomControl: false,
      maxZoom: 19,
      // Leaflet snaps the result of fitBounds/flyToBounds to a whole zoom level
      // by default (zoomSnap: 1), and it snaps *down* — so a path that would fit
      // at 16.9 is shown at 16, half the scale it could be. That alone is why
      // the expanded view looked zoomed out. Zero lets the fit land on the exact
      // level the bounds allow.
      //
      // The +/- controls are unaffected: they step by `zoomDelta`, still 1.
      zoomSnap: 0
    }).setView([this.lat, this.long], this.zoom);

    // Base tiles follow the app theme and re-swap when it is toggled. The
    // branch this replaced read localStorage once, so the map kept whatever
    // theme it started with.
    this.disposeMapTheme?.();
    this.disposeMapTheme = this.mapTheme.bind(this.map, { minZoom: 12, maxZoom: 19 });
    // Add zoom control
    Leaflet.control.zoom({
      position: 'bottomright'
    }).addTo(this.map);

    this.observeMapResize();
  }

  /**
   * Expand the map to the full viewport, and back.
   *
   * The state is a single flag; `.is-expanded` in the stylesheet does the rest,
   * lifting the map shell to `position: fixed; inset: 0`. The overlays inside it
   * — status pill, tools, playback bar — are already absolute against that
   * shell, so they follow with no second set of rules.
   *
   * Nothing here calls invalidateSize(): the ResizeObserver set up alongside the
   * map sees the box change and handles it. The open animation is opacity and
   * transform only — the element is full size from its first frame — so that
   * fires once rather than on every frame of the transition.
   */
  toggleMapExpand(): void {
    const expanding = !this.isMapExpanded;

    // The 3PL sheet is confined to this same column (see its SCSS), so
    // expanding the map over it would otherwise leave it open underneath,
    // unreachable and still (nominally) "open". The ControlX sheet is
    // mobile-only but does cover the screen there, same reasoning.
    if (expanding && this.show3plSheet) {
      this.close3plSheet();
    }
    if (expanding && this.showControlxSheet) {
      this.closeControlxSheet();
    }

    if (expanding && this.map) {
      this.collapsedView = { center: this.map.getCenter(), zoom: this.map.getZoom() };
    }

    // Closing the map takes the countdown with it — it is drawn inside the map,
    // so leaving it running would start a replay nobody can see.
    if (!expanding) {
      this.cancelPlayCountdown();
    }

    this.isMapExpanded = expanding;
    this.setPageScrollLock(expanding);

    // The expanded view opens both endpoint cards without being asked -- it is
    // the view people go to in order to read the whole route, and there is room
    // for them there. Collapsing back into the column closes them again and
    // hands control back to click-to-open, where two permanent cards would
    // cover most of a ~400px map.
    this.pointTipOpen.pickup = expanding;
    this.pointTipOpen.delivery = expanding;
    this.syncPointTips();

    // Don't re-frame here, and don't guess at a frame or two either.
    //
    // Leaflet works the zoom out against the container size it currently
    // believes it has. Fitting before the box has actually grown produces a zoom
    // computed for the ~400px column and then applied to a ~2000px screen — the
    // path ends up occupying a fifth of the width, about 2.3 zoom levels short,
    // which is exactly the symptom this replaced.
    //
    // So the fit waits for the ResizeObserver, which fires on the real geometry
    // change and calls invalidateSize() before handing over.
    this.pendingMapFit = true;
    // Fallback for the one case the observer cannot cover: a box that does not
    // change size at all (already full-bleed on a small screen), where no resize
    // is ever reported and the fit would otherwise never run.
    setTimeout(() => this.flushPendingMapFit(), 260);
  }

  /**
   * Runs the re-frame that `toggleMapExpand()` deferred, once — whichever of the
   * observer or the fallback timer gets here first.
   */
  private flushPendingMapFit(): void {
    if (!this.pendingMapFit) return;
    this.pendingMapFit = false;
    this.applyMapExpandView(this.isMapExpanded);
  }

  /**
   * The insets to keep clear when fitting the rider's path, as
   * `{ topLeft, bottomRight }` pixel pairs for Leaflet's padding options.
   *
   * `expandedFitPadding` on all four sides is the requirement, but a flat inset
   * measures from the canvas edge — and the canvas edge is not where the map
   * becomes visible. The playback bar, the status pill and the tool buttons are
   * drawn over it, so 50px from the bottom edge still leaves the end of the path
   * underneath the scrubber.
   *
   * The overlays are measured rather than hard-coded: their heights come from
   * their content (a two-line status pill, a wrapped player bar on a narrow
   * screen) and from the stylesheet, and either can change without this file
   * knowing. Reading the rendered boxes keeps the two in step.
   */
  private expandedFitInsets(): { topLeft: [number, number], bottomRight: [number, number] } {
    const base = this.expandedFitPadding;
    const canvas: HTMLElement | null = this.map?.getContainer?.() ?? null;
    const shell = canvas?.closest?.('.ad-od-map') as HTMLElement | null;
    if (!shell) return { topLeft: [base, base], bottomRight: [base, base] };

    const box = shell.getBoundingClientRect();
    // How far each overlay reaches in from its own edge — its height plus
    // whatever gap the stylesheet leaves between it and the edge.
    const reachFromTop = (selector: string): number => {
      const el = shell.querySelector(selector) as HTMLElement | null;
      if (!el) return 0;
      return Math.max(0, el.getBoundingClientRect().bottom - box.top);
    };
    const reachFromBottom = (selector: string): number => {
      const el = shell.querySelector(selector) as HTMLElement | null;
      if (!el) return 0;
      return Math.max(0, box.bottom - el.getBoundingClientRect().top);
    };

    const top = Math.max(reachFromTop('.ad-od-map__badge'), reachFromTop('.ad-od-map__tools'));
    const bottom = reachFromBottom('.ad-od-player');

    return {
      topLeft: [base, base + top],
      bottomRight: [base, base + bottom]
    };
  }

  /** Re-frames the map for whichever size it has just become. */
  private applyMapExpandView(expanded: boolean): void {
    if (!this.map) return;

    // The ResizeObserver would get here on its own, but the camera moves below
    // depend on the new size being known *now*, not next frame.
    this.map.invalidateSize(false);

    if (expanded) {
      const journey = this.riderJourneyBounds();

      if (journey) {
        // flyToBounds rather than fitBounds: it eases the pan and the zoom
        // together, so arriving at the journey reads as travel, not a cut.
        const insets = this.expandedFitInsets();
        this.map.flyToBounds(journey, {
          // Pixel insets, not `bounds.pad()`. `.pad()` grows the box by a
          // fraction of its own size, so a two-street trip would get a few
          // metres of margin and a cross-city one kilometres — the gap round the
          // path changing with every order. 50px is 50px whatever it measures.
          //
          // Top and bottom carry the map's own overlays on top of that 50px, so
          // the clearance is from the chrome rather than from the canvas edge.
          paddingTopLeft: insets.topLeft,
          paddingBottomRight: insets.bottomRight,
          // Deliberately no maxZoom: the expanded view is meant to be as close
          // as the path will go while staying whole, so the only ceiling is the
          // tile layer's own.
          duration: 0.7
        });
        return;
      }

      // Nothing of the rider to frame — no path, no markers, no location yet.
      // Holding the small map's crop would waste the extra room, so spend it on
      // the planned route instead.
      this.fitAllRoutes();
      return;
    }

    if (this.collapsedView) {
      this.map.setView(this.collapsedView.center, this.collapsedView.zoom, { animate: true, duration: 0.45 });
      this.collapsedView = null;
    }
  }

  /**
   * The box the expanded view frames: everything the rider's path is made of.
   *
   * Measured off the rendered polyline — the `.leaflet-interactive` element
   * itself — rather than off the array it was drawn from. The layer is only
   * (re)drawn when the trail has more than one point and it survives while fresh
   * data is being fetched, so asking the layer guarantees the frame contains
   * exactly the line on screen. `riderTrackPoints` stays as the fallback for the
   * window before that layer exists.
   *
   * Markers are folded in with extend() so they can only widen the box, never
   * shrink it — they matter solely for the case where one has been placed but
   * the path behind it has not been drawn yet.
   *
   * Nothing else belongs here, in particular not the planned pickup/delivery
   * routes: every extra coordinate widens the box and lowers the fitted zoom,
   * which is the opposite of what this view is for.
   *
   * Returns null when there is nothing to frame — the caller's cue to fall back
   * rather than fly to an empty box.
   */
  private riderJourneyBounds(): any {
    let bounds: any = null;

    const drawn = this.riderLiveRouteLayer?.getBounds?.();
    if (drawn?.isValid?.()) {
      // Copy rather than use it directly: extend() below mutates, and this is
      // the live layer's own bounds object.
      bounds = Leaflet.latLngBounds(drawn.getSouthWest(), drawn.getNorthEast());
    }

    if (!bounds) {
      const coords = (this.riderTrackPoints || []).map(p => Leaflet.latLng(p.lat, p.lng));
      if (coords.length) bounds = Leaflet.latLngBounds(coords);
    }

    for (const point of [this.riderJourneyStart(), this.riderJourneyEnd()]) {
      if (!point) continue;
      bounds = bounds ? bounds.extend(point) : Leaflet.latLngBounds([point, point]);
    }

    return bounds?.isValid?.() ? bounds : null;
  }

  /**
   * Where the rider's recorded journey begins — the marker if it has been placed,
   * otherwise the first point of the track it was placed from. Both read the
   * same loc-track record, so they agree; the fallback only covers the window
   * before `addRiderStartMarker()` has run.
   */
  private riderJourneyStart(): any {
    const marker = this.riderStartMarker?.getLatLng?.();
    if (marker) return marker;

    const first = this.riderTrackPoints?.[0];
    return first ? Leaflet.latLng(first.lat, first.lng) : null;
  }

  /**
   * Where it currently ends. The live marker leads, because during a replay it
   * is the one the user is watching; the last recorded point and the raw
   * location back it up when no marker exists yet.
   */
  private riderJourneyEnd(): any {
    const marker = this.riderMarker?.getLatLng?.();
    if (marker) return marker;

    const last = this.riderTrackPoints?.[this.riderTrackPoints.length - 1];
    if (last) return Leaflet.latLng(last.lat, last.lng);

    return this.riderLocation ? Leaflet.latLng(this.riderLocation.lat, this.riderLocation.lng) : null;
  }

  // Escape is what people try first in anything full-screen, and it is the only
  // way out for someone who reached the button by keyboard.
  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    // Whichever overlay is open is the thing on top, so it is the thing
    // Escape means. The 3PL sheet is confined to the map column rather than
    // the whole page, so openProofViewer()/toggleMapExpand() close it first
    // if it was open - same for the ControlX sheet, which is mobile-only
    // but does cover the screen there. None of the four can be open
    // together, just via an explicit handoff now instead of being
    // unreachable by construction.
    if (this.show3plSheet) {
      this.close3plSheet();
      return;
    }
    if (this.showControlxSheet) {
      this.closeControlxSheet();
      return;
    }
    if (this.proofViewer) {
      this.closeProofViewer();
      return;
    }
    if (this.isMapExpanded) {
      this.toggleMapExpand();
    }
  }

  // ---------------------------------------------------------------------------
  // 3PL Allocation — inline card before assignment, bottom sheet after
  // ---------------------------------------------------------------------------

  /** Whether there is anything to show at all — inline card or sheet trigger. */
  get has3plAllocation(): boolean {
    return !!(this.thirdPartyAllocation && this.thirdPartyAllocation.length > 0);
  }

  /**
   * True for created/pending — before the order has actually landed on a
   * 3PL. Allocation *attempts* can already exist here (a failed or retried
   * assignment), which is worth keeping prominent as an inline card while
   * it's still live and unresolved. Once Assigned, that history is settled
   * and moves behind the compact sheet trigger instead — see has3plAllocation
   * usage in the template for both branches.
   *
   * An explicit allow-list rather than an order_status_id comparison: the
   * numeric ids do not follow the real status flow (created=1, pending=2,
   * assigned=3, but pickedUp=4 while arrivedAtPickup=11 sits after it, etc.),
   * so "before assigned" cannot be expressed as id < 3.
   *
   * An order that has been Assigned once and fell back to Pending
   * (Pending -> Assigned -> Pending) counts as past assignment: it keeps the
   * sheet trigger rather than bringing the inline card back.
   */
  get isBeforeAssigned(): boolean {
    const id = this.orderData?.order_status_id;
    return (id === this.constant.OrderStatusId.created || id === this.constant.OrderStatusId.pending)
      && !this.hasBeenAssigned;
  }

  /** Whether an Assigned row exists anywhere in the flow history. */
  get hasBeenAssigned(): boolean {
    return !!this.orderflows?.some((flow: any) => flow?.order_status_id === this.constant.OrderStatusId.assigned);
  }

  /**
   * The Order Status card stays hidden only for an order that is Pending and
   * has never been assigned. Once an Assigned row exists in the flow history it
   * shows for good -- so Pending -> Assigned -> Pending and re-assignments
   * (a second Assigned row) keep the card, since there is a journey to show.
   */
  get isPendingNeverAssigned(): boolean {
    return this.orderData?.order_status_id === this.constant.OrderStatusId.pending && !this.hasBeenAssigned;
  }

  // Confined to .ad-od-col--map (see the component SCSS), not the whole
  // page, so unlike the proof viewer / expanded map this never takes the
  // page scroll lock — the rest of the page stays interactive underneath.
  open3plSheet(): void {
    if (!this.has3plAllocation) return;
    // Mobile footer nav is a two-tab switcher: opening one sheet closes the
    // other rather than stacking both.
    if (this.showControlxSheet) {
      this.closeControlxSheet();
    }
    // Reopened mid-exit: cancel the pending unmount and play the entrance
    // again from the current state instead.
    clearTimeout(this.threePlSheetCloseTimer);
    this.is3plSheetClosing = false;
    this.threePlSheetReturnFocus = (typeof document !== 'undefined'
      ? document.activeElement as HTMLElement
      : null);
    this.show3plSheet = true;
  }

  close3plSheet(): void {
    if (!this.show3plSheet || this.is3plSheetClosing) return;
    // Back to the button that opened it, so a keyboard user resumes where
    // they were rather than at the top of the document. preventScroll for
    // the same reason as on open: no jump while the sheet slides away.
    this.threePlSheetReturnFocus?.focus?.({ preventScroll: true });
    this.threePlSheetReturnFocus = null;

    // Slide down + fade out, then unmount. Reduced motion has no exit
    // animation (see the prefers-reduced-motion block), so it unmounts now.
    const reduceMotion = typeof window !== 'undefined'
      && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      this.show3plSheet = false;
      return;
    }
    this.is3plSheetClosing = true;
    this.threePlSheetCloseTimer = setTimeout(() => {
      this.show3plSheet = false;
      this.is3plSheetClosing = false;
    }, OrderDetailViewComponent.SHEET_EXIT_MS);
  }

  on3plSheetKeydown(event: KeyboardEvent): void {
    this.trapFocusWithin(event, this.threePlSheetEl?.nativeElement);
  }

  // ---------------------------------------------------------------------------
  // ControlX activities — mobile sheet mode for the same rail aside
  // ---------------------------------------------------------------------------

  // Unlike the 3PL sheet, this genuinely covers the screen on mobile (there
  // is no column to confine it to below 768.98px - the whole layout is one
  // stacked column by then), so it takes the page scroll lock like the
  // proof viewer / expanded map do, guarded the same defensive way.
  openControlxSheet(): void {
    if (this.show3plSheet) {
      this.close3plSheet();
    }
    this.controlxSheetReturnFocus = (typeof document !== 'undefined'
      ? document.activeElement as HTMLElement
      : null);
    this.showControlxSheet = true;
    if (!this.isMapExpanded && !this.proofViewer) {
      this.setPageScrollLock(true);
    }
    // No ViewChild-setter to hook this to (see showControlxSheet) - the
    // close button already exists, it just wasn't focusable/visible a
    // moment ago, so focus it directly now that .is-open is set.
    this.controlxSheetCloseEl?.nativeElement.focus();
  }

  closeControlxSheet(): void {
    if (!this.showControlxSheet) return;
    this.showControlxSheet = false;
    if (!this.isMapExpanded && !this.proofViewer) {
      this.setPageScrollLock(false);
    }
    this.controlxSheetReturnFocus?.focus?.();
    this.controlxSheetReturnFocus = null;
  }

  /**
   * The floating pill (769–1399.98px, see _controlx.scss "DOCKED MODE") sits
   * beside the panel it opens rather than being covered by it, so it stays
   * clickable while open and has to toggle. The footer tab below 768.98px
   * is covered by its own sheet, so that one only ever opens.
   */
  toggleControlxSheet(): void {
    if (this.showControlxSheet) {
      this.closeControlxSheet();
    } else {
      this.openControlxSheet();
    }
  }

  // Guarded on showControlxSheet, unlike on3plSheetKeydown/onProofViewerKeydown:
  // this aside is always in the DOM (it's also the desktop rail), so without
  // the guard Tab would get trapped inside it even when it's just sitting
  // there as a persistent panel, not acting as a sheet.
  onControlxSheetKeydown(event: KeyboardEvent): void {
    if (!this.showControlxSheet) return;
    this.trapFocusWithin(event, this.controlxSheetEl?.nativeElement);
  }

  // ---------------------------------------------------------------------------
  // Proof lightbox
  // ---------------------------------------------------------------------------

  /**
   * Opens a proof image full-screen. `label` and `name` are the caption and the
   * download name the tile already uses, passed straight through.
   */
  openProofViewer(src: string, label: string, name: string): void {
    if (!src) return;
    // The 3PL sheet is confined to the map column, not the whole page (see
    // its SCSS), so - unlike the expanded map - it does not block reaching
    // the Proof Details card in another column while it's open. The
    // ControlX sheet's own backdrop should already make this unreachable in
    // practice on mobile, but the guard is cheap and matches the pattern.
    if (this.show3plSheet) {
      this.close3plSheet();
    }
    if (this.showControlxSheet) {
      this.closeControlxSheet();
    }
    this.proofViewerReturnFocus = (typeof document !== 'undefined'
      ? document.activeElement as HTMLElement
      : null);
    this.proofViewer = { src, label, name };
    // The expanded map holds the same lock and stored the page's real overflow
    // in doing so; taking it again here would record 'hidden' as the value to
    // restore and strand the page unscrollable. In practice the two cannot
    // overlap - the proof card is behind the full-screen map - but the guard
    // costs nothing and the failure would be silent.
    if (!this.isMapExpanded) {
      this.setPageScrollLock(true);
    }
  }

  closeProofViewer(): void {
    if (!this.proofViewer) return;
    this.proofViewer = null;
    if (!this.isMapExpanded) {
      this.setPageScrollLock(false);
    }
    // Back to the tile that opened it, so a keyboard user resumes where they
    // were rather than at the top of the document.
    this.proofViewerReturnFocus?.focus?.();
    this.proofViewerReturnFocus = null;
  }

  /**
   * Keeps Tab inside a dialog. The proof viewer has two controls (Download,
   * Close) and the 3PL sheet has one (Close); the list is queried rather
   * than hard-coded so either can gain more without a change here.
   */
  private trapFocusWithin(event: KeyboardEvent, root: HTMLElement | undefined): void {
    if (event.key !== 'Tab' || !root) return;

    const items = Array.from(root.querySelectorAll<HTMLElement>('button:not([disabled])'));
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement as HTMLElement | null;

    // Wrapping backwards also covers the case where focus has escaped the
    // dialog entirely - anything not in the list is treated as "before first".
    if (event.shiftKey && (active === first || !active || !items.includes(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  onProofViewerKeydown(event: KeyboardEvent): void {
    this.trapFocusWithin(event, this.proofViewerEl?.nativeElement);
  }

  // The expanded map covers the viewport, so a page scrolling underneath it is
  // movement with nothing to show for it. Restores the previous value rather
  // than clearing, in case the host page (or a modal) had its own.
  private setPageScrollLock(locked: boolean): void {
    if (typeof document === 'undefined') return;
    if (locked) {
      this.bodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = this.bodyOverflow;
      this.bodyOverflow = '';
    }
  }

  /**
   * Keep Leaflet's idea of the canvas in step with its actual box.
   *
   * The map no longer has a fixed height: it is the flexible element of its
   * column, so it resizes whenever the cards beneath it do — an order flow
   * arriving, a card appearing once its data loads, the 3PL list growing. Leaflet
   * binds to `window.resize` on its own but has no way to see a container-only
   * reflow, and until `invalidateSize()` runs it keeps drawing for the old box:
   * grey bands down the side, and clicks landing off-target because the pixel
   * origin is stale.
   */
  private observeMapResize() {
    this.disposeMapResize?.();
    this.disposeMapResize = undefined;

    const el = this.map?.getContainer?.();
    if (!el || typeof ResizeObserver === 'undefined') return;

    const observer = new ResizeObserver(() => {
      // Coalesce to one call per frame: a flex reflow can fire the observer
      // several times in a row, and invalidateSize() redraws every layer.
      if (this.mapResizeFrame !== null) return;
      this.mapResizeFrame = requestAnimationFrame(() => {
        this.mapResizeFrame = null;
        // `false` — no pan animation. The container moved, the view did not, so
        // animating reads as the map drifting on its own.
        this.map?.invalidateSize(false);
        // And only now, with Leaflet's idea of the box matching the real one, is
        // it safe to re-frame. See flushPendingMapFit().
        this.flushPendingMapFit();
      });
    });

    observer.observe(el);
    this.disposeMapResize = () => {
      observer.disconnect();
      if (this.mapResizeFrame !== null) {
        cancelAnimationFrame(this.mapResizeFrame);
        this.mapResizeFrame = null;
      }
    };
  }

  async addOrderMarkers() {
    if (!this.orderData) return;
    if (!this.map) return;

    // Drop the previous set before drawing the new one. Without this the pins
    // from every earlier poll stay on the map -- see orderMarkerLayer's note.
    this.pickupPointMarker = null;
    this.deliveryPointMarker = null;
    if (this.orderMarkerLayer) {
      this.orderMarkerLayer.clearLayers();
    } else {
      this.orderMarkerLayer = Leaflet.layerGroup().addTo(this.map);
    }

    const markers: any[] = [];

    // Add marker for pickup point
    if (this.isValidCoordinate(this.orderData.pickup_lat, this.orderData.pickup_long)) {
      const pickupMarker = Leaflet.marker(
        [Number(this.orderData.pickup_lat), Number(this.orderData.pickup_long)],
        { icon: constant.mapIcons.storeIcon }
      ).addTo(this.orderMarkerLayer);
      this.pickupPointMarker = pickupMarker;
      this.attachPointTip(pickupMarker, 'pickup',
        this.buildPointTipHtml('Pickup', this.orderData?.pickup_contact_name, this.orderData?.pickup_cl_city_id));
      markers.push(pickupMarker);
    }

    // Add marker for delivery point
    if (this.isValidCoordinate(this.orderData.delivery_lat, this.orderData.delivery_long)) {
      const deliveryMarker = Leaflet.marker(
        [Number(this.orderData.delivery_lat), Number(this.orderData.delivery_long)],
        { icon: constant.mapIcons.customerIcon }
      ).addTo(this.orderMarkerLayer);
      this.deliveryPointMarker = deliveryMarker;
      this.attachPointTip(deliveryMarker, 'delivery',
        this.buildPointTipHtml('Delivery', this.orderData?.delivery_contact_name, this.orderData?.drop_cl_city_id));
      markers.push(deliveryMarker);
    }

    // Utility: check for "falsy"/invalid coordinates including 00.0000... or undefined/null/empty/zero
    const isInvalidLatLng = (lat: any, lng: any) => {
      const nLat = typeof lat === 'string' ? parseFloat(lat) : lat;
      const nLng = typeof lng === 'string' ? parseFloat(lng) : lng;
      // Falsy, empty, undefined, null, zero as string, '0', '0.0', '00.00000', etc.
      if (
        (!nLat && !nLng) ||
        (nLat === 0 && nLng === 0) ||
        (isNaN(nLat) && isNaN(nLng)) ||
        (nLat === undefined && nLng === undefined) ||
        (nLat === null && nLng === null)
      ) {
        return true;
      }
      // Specifically treat "0", "0.0", "00.00000", etc
      const strLat = (lat !== undefined && lat !== null) ? String(lat).replace(/[\s]+/g, '') : '';
      const strLng = (lng !== undefined && lng !== null) ? String(lng).replace(/[\s]+/g, '') : '';
      const invalidStr = (val: string) => /^0+(\.0+)?$/.test(val) || val === '';
      if (invalidStr(strLat) && invalidStr(strLng)) {
        return true;
      }
      return false;
    };

    // Add order flow markers with different colors based on status
    // To avoid overlapping markers, if two markers are at the same place, move the new one by ~5m
    const placedCoords: { lat: number, lng: number }[] = [];
    const OFFSET_METERS = 10;
    const metersToDegreesLat = (meters: number) => meters / 111320; // 1 deg lat ~ 111.32km
    const metersToDegreesLng = (meters: number, lat: number) => meters / (111320 * Math.cos(lat * Math.PI / 180));

    this.orderflows.forEach((item: any, index: number) => {
      // NEW: use advanced check for invalid coords including all silly zero/empty/undefined etc combos
      if (!isInvalidLatLng(item?.lat, item?.long)) {
        let lat = Number(item.lat);
        let lng = Number(item.long);

        // Check for overlap with already placed markers
        let overlapCount = 0;
        for (const coord of placedCoords) {
          // Consider as overlap if within ~2 meters
          const dLat = lat - coord.lat;
          const dLng = lng - coord.lng;
          const dist = Math.sqrt(
            Math.pow(dLat * 111320, 2) + Math.pow(dLng * 111320 * Math.cos(lat * Math.PI / 180), 2)
          );
          if (dist < 2) {
            overlapCount++;
          }
        }

        // If overlap, offset the marker by 5m * overlapCount in a unique direction
        if (overlapCount > 0) {
          // Spread out in a circle, angle based on index
          const angle = (index * 45) % 360; // degrees
          const angleRad = angle * Math.PI / 180;
          const offsetLat = metersToDegreesLat(OFFSET_METERS * overlapCount * Math.sin(angleRad));
          const offsetLng = metersToDegreesLng(OFFSET_METERS * overlapCount * Math.cos(angleRad), lat);
          lat += offsetLat;
          lng += offsetLng;
        }

        placedCoords.push({ lat, lng });

        const statusName = constant.OrderStatusName[item.order_status_id as keyof typeof constant.OrderStatusName] || 'Unknown Status';
        const statusColor = this.getStatusColor(item.order_status_id);
        var statusShortName = statusName[0];
        if (item.order_status_id == 11) {
          statusShortName = 'AP';
        }

        let tooltipLabel = statusName;
        if (item.order_status_id == constant.OrderStatusId.assigned) {
          const matchedFlow = (this.thirdPartyAllocation || []).find((f: any) => f.order_status_id == item.order_status_id && f.date_time === item.date_time);
          const partnerName = matchedFlow?.delivery_staff_id ? 'Ek-bharat'
            : matchedFlow?.delivery_partner_user_id ? (matchedFlow?.DeliveryPartner?.full_name || '')
              : '';
          const formattedDate = this.orderDateFormat(item.date_time, constant.timeFromatHtmlWithSec);
          tooltipLabel = partnerName ? `${statusName} -${partnerName} -${formattedDate}` : `${statusName} -${formattedDate}`;
        }

        const flowMarker = Leaflet.marker([lat, lng], {
          icon: Leaflet.divIcon({
            className: 'custom-flow-marker',
            html: `<div style="background-color: ${statusColor}; width: 30px; height: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 14px; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px; color: white; font-weight: 600;" title="${statusName}">${statusShortName}</div>`,
            iconSize: [16, 16],
            iconAnchor: [8, 8]
          })
        }).addTo(this.orderMarkerLayer);

        // Add a Leaflet tooltip to show the status name (and, for Assigned, the delivery
        // partner + timestamp) on hover
        flowMarker.bindTooltip(tooltipLabel, {
          direction: 'top',
          offset: [0, -18],
          className: 'order-status-tooltip'
        });

        markers.push(flowMarker);
      }
    });

    // Frame the markers on the first paint only. This used to run on every
    // 10s poll, so any pan or zoom the user made was snapped away a few
    // seconds later. resetMapView() is the deliberate way back to this framing.
    if (markers.length > 0 && !this.hasFitOrderMarkers) {
      this.hasFitOrderMarkers = true;
      const group = new Leaflet.FeatureGroup(markers);
      this.map.fitBounds(group.getBounds().pad(0.1));
    }

    // The blue planned route only needs pickup/delivery coordinates, not rider GPS — draw it here
    // so it's on the map even before any rider location ping ever arrives.
    await this.ensurePickupToDeliveryRoute();

    // In case loc track data arrived before the map/pickup point were ready
    this.updateRiderLocation();
  }

  /**
   * Shared options for the pickup/delivery cards.
   *
   * `permanent` because the reference shows both open at once with nothing
   * hovered — these label the two fixed ends of the journey, so they are not
   * really tooltips, they are captions.
   *
   * The offset clears the pin rather than sitting on it. storeIcon/customerIcon
   * are 50x55 anchored at [25, 51], so the artwork rises 51px above the
   * coordinate; Leaflet puts a `top` tooltip's bottom edge at that coordinate
   * plus the offset, so anything shallower than -51 tucks the card behind the
   * pin. -54 leaves a small gap. No x offset: the anchor is now the pin's
   * horizontal centre, so centring on the coordinate centres on the pin.
   */
  private static readonly POINT_TIP_OPTIONS: any = {
    permanent: true,
    direction: 'top',
    offset: [0, -54],
    opacity: 1,
    className: 'ad-od-point-tip'
  };

  /**
   * Binds an endpoint card and wires it to click.
   *
   * The card is bound `permanent` and then driven by hand. That reads oddly but
   * is deliberate: a non-permanent Leaflet tooltip wires up its own
   * mouseover/mouseout handlers, so the card would flicker open on hover and
   * fight the click toggle. `permanent` binds no handlers of its own and leaves
   * open/close entirely to openTooltip()/closeTooltip().
   *
   * Binding a permanent tooltip to a marker already on the map opens it
   * immediately, so the sync at the end is what actually establishes the
   * starting state -- closed in the column, open in the expanded view, or
   * whatever the user last chose.
   */
  private attachPointTip(marker: any, key: 'pickup' | 'delivery', html: string): void {
    marker.bindTooltip(html, OrderDetailViewComponent.POINT_TIP_OPTIONS);
    marker.on('click', () => {
      this.pointTipOpen[key] = !this.pointTipOpen[key];
      this.syncPointTip(marker, key);
    });
    this.syncPointTip(marker, key);
  }

  private syncPointTip(marker: any, key: 'pickup' | 'delivery'): void {
    if (!marker) return;
    if (this.pointTipOpen[key]) marker.openTooltip();
    else marker.closeTooltip();
  }

  /** Re-applies both cards after something changed the intent behind them. */
  private syncPointTips(): void {
    this.syncPointTip(this.pickupPointMarker, 'pickup');
    this.syncPointTip(this.deliveryPointMarker, 'delivery');
  }

  /**
   * Label / name / city card for a journey endpoint.
   *
   * Leaflet sets tooltip content as innerHTML, and both the contact name and
   * the city id come straight off the order payload, so every interpolated
   * value is escaped. Name and city are each dropped when absent rather than
   * rendering an empty row, which would leave the card looking clipped.
   */
  private buildPointTipHtml(label: string, name: any, city: any): string {
    const rows = [`<span class="ad-od-point-tip__label">${this.escapeHtml(label)}</span>`];
    const contact = String(name ?? '').trim();
    const cityId = String(city ?? '').trim();
    if (contact) rows.push(`<span class="ad-od-point-tip__name">${this.escapeHtml(contact)}</span>`);
    if (cityId) rows.push(`<span class="ad-od-point-tip__city">${this.escapeHtml(cityId)}</span>`);
    return rows.join('');
  }

  /** Same helper the other map screens use before handing Leaflet innerHTML. */
  private escapeHtml(value: string): string {
    const map: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
    return value.replace(/[&<>"']/g, char => map[char]);
  }

  isValidCoordinate(lat: any, lng: any): boolean {
    if (!lat || !lng) return false;
    const latitude = parseFloat(lat);
    const longitude = parseFloat(lng);
    return !isNaN(latitude) && !isNaN(longitude) &&
      latitude >= -90 && latitude <= 90 &&
      longitude >= -180 && longitude <= 180;
  }

  getStatusColor(statusId: number): string {
    const colorMap: { [key: number]: string } = {
      1: '#c5cae9',
      2: '#ffaa00',
      3: '#7fb800',
      4: '#006bf6',
      5: '#0eb05c',
      6: '#ff595e',
      7: '#d90429',
      8: '#f4937a',
      9: '#7f77ea',
      11: '#f3732f',
      10: '#f7a172',
      13: '#f77281',
      15: '#0eb05c',
      14: '#f4937a',
    };
    return colorMap[statusId] || '#6c757d';
  }


  // copyToClipboard(text: string) {
  //   if (text && text != '--' && text != 'N/A' && text != '') {
  //     navigator.clipboard.writeText(text).then(() => {
  //       this.toaster.success('Copied to clipboard', 'Success');
  //     }).catch(err => {
  //       console.error('Failed to copy text: ', err);
  //       this.toaster.error('Failed to copy text');
  //     });
  //   } else {
  //     this.toaster.error('No valid text to copy');
  //     console.error('No valid text to copy');
  //   }
  // }
  copyToClipboard(text: string, dataType?: string) {
    const message = dataType ? `${dataType} copied to clipboard` : 'Text copied to clipboard';

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        this.toaster.success(message);
      }).catch(err => {
        this.toaster.error('Failed to copy to clipboard');
        console.error('Error copying to clipboard:', err);
      });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        this.toaster.success(message);
      } catch (err) {
        this.toaster.error('Failed to copy to clipboard');
        console.error('Error copying to clipboard:', err);
      }
      document.body.removeChild(textArea);
    }
  }

  makeCall(phoneNumber: string) {
    window.open(`tel:${phoneNumber}`, '_self');
  }

  generateIGM() {
    const modalRef = this.modalService.open(IssueModelComponent, {
      scrollable: true,
      windowClass: "myCustomModalClass",
      size: "lg",
      // keyboard: false,
      // backdrop: 'static'
    });

    modalRef.componentInstance.orderData = { orderId: this.orderId };
    modalRef.result.then(
      (result) => { },
      (reason) => { }
    );
  }
  blockPopup() {
    if (!this.canBlockRider || this.buttonDisabled) return;
    // Use SweetAlert2 for popup with input field for block reason
    Swal.fire({
      title: 'Block Rider',
      text: 'Please provide a reason for blocking this rider:',
      input: 'text',
      inputPlaceholder: 'Enter block reason',
      inputAttributes: {
        maxlength: '100',
        autocapitalize: 'off',
        autocorrect: 'off'
      },
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Block',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#d33',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        const input = Swal.getInput();
        const confirmBtn = Swal.getConfirmButton();
        if (input && confirmBtn) {
          confirmBtn.disabled = true;
          input.addEventListener('input', function () {
            if ((input as HTMLInputElement).value.trim() === '') {
              confirmBtn.disabled = true;
            } else {
              confirmBtn.disabled = false;
            }
          });
        }
      },
      preConfirm: (value: string) => {
        if (!value || value.trim() === '') {
          return false;
        }
        return value.trim();
      }
    }).then((result: any) => {
      if (result.isConfirmed && result.value && result.value.trim() !== '') {
        this.blockRiderReason = result.value.trim();
        this.blockRider();
      }
    });
  }

  blockRider() {
    // 3PL rider details come under OrderDetail.delivery_partner_rider_dtl; platform name falls back to the delivery partner's name
    const orderDetail = this.orderData?.OrderDetail;
    const dpRider = orderDetail?.delivery_partner_rider_dtl;
    const dpName = orderDetail?.rider_platform_name || this.orderData?.rider_platform_name || this.orderData?.DeliveryPartner?.full_name || this.riderPlatformName || '';
    var reqJson = {
      "delivery_staff_id": this.orderData?.DeliveryStaff?.delivery_staff_id,
      "ds_master_agency_user_id": this.orderData?.oo_master_agency_user_id ?? this.orderData?.master_agency_user_id,
      "ds_agency_user_id": this.orderData?.oo_agency_user_id ?? this.orderData?.agency_user_id,
      "order_id": this.orderId,
      "op_order_id": this.orderData?.partner_order_id,
      "op_user_id": this.orderData?.order_from_user_id,
      "block_reason": this.blockRiderReason,
      // "dp_name": this.orderData?.orderDetails?.rider_platform_name || this.orderData?.rider_platform_name || '',
      // "rider_name": this.orderData?.orderDetails?.delivery_partner_rider_dtl.full_name || this.orderData?.DeliveryStaff?.full_name || '',
      // "rider_phone": this.orderData?.orderDetails?.delivery_partner_rider_dtl.phone || this.orderData?.DeliveryStaff?.phone || '',
      // "rider_platform_name": (this.orderData?.DeliveryStaff) ? 'Ek-Bharat' : this.orderData?.orderDetails?.rider_platform_name,
      // "delivery_partner_user_id": this.orderData?.DeliveryPartner?.user_id
      "dp_name": dpName,
      "rider_name": dpRider?.full_name || this.orderData?.DeliveryStaff?.full_name || this.orderData?.rider_name || '',
      "rider_phone": dpRider?.phone || this.orderData?.DeliveryStaff?.phone || this.orderData?.rider_phone || '',
      "rider_platform_name": (this.orderData?.DeliveryStaff) ? 'Ek-Bharat' : dpName,
      "delivery_partner_user_id": this.orderData?.DeliveryPartner?.user_id
    };
    if (this.orderData?.DeliveryStaff && this.orderData?.DeliveryStaff?.delivery_staff_id) {
      reqJson.dp_name = 'Ek-Bharat';
      reqJson.rider_name = this.orderData?.DeliveryStaff?.full_name;
      reqJson.rider_phone = this.orderData?.DeliveryStaff?.phone;
      reqJson.delivery_partner_user_id = this.orderData?.DeliveryPartner?.user_id;
    }
    this.http.postData(constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.RiderBlock, reqJson).subscribe((response: any) => {
      if (response.status) {
        this.toaster.success('Rider blocked successfully');
      } else {
        this.toaster.error(response.message);
      }
    });
  }

  hasObjectKeys(obj: any): boolean {
    return obj && Object.keys(obj).length > 0;
  }

  calculateTimeDifference(currentIndex: number): string {
    if (!this.thirdPartyAllocation || this.thirdPartyAllocation.length === 0) {
      return '';
    }

    const currentEntry = this.thirdPartyAllocation[currentIndex];

    if (!currentEntry?.date_time) {
      return '';
    }

    try {
      const currentTime = new Date(currentEntry.date_time).getTime();
      let timeDiffMs: number;

      if (currentIndex === 0) {
        // For the first entry (most recent), calculate time from now
        const now = new Date().getTime();
        timeDiffMs = now - currentTime;
      } else {
        // For other entries, calculate time from the previous entry
        const previousEntry = this.thirdPartyAllocation[currentIndex - 1];
        if (!previousEntry?.date_time) {
          return '';
        }
        const previousTime = new Date(previousEntry.date_time).getTime();
        timeDiffMs = previousTime - currentTime;
      }

      const timeDiffMinutes = Math.floor(timeDiffMs / (1000 * 60));
      const timeDiffSeconds = Math.floor((timeDiffMs % (1000 * 60)) / 1000);

      if (timeDiffMinutes > 0) {
        return `${timeDiffMinutes} min${timeDiffMinutes > 1 ? 's' : ''}`;
      } else if (timeDiffSeconds > 0) {
        return `${timeDiffSeconds} sec${timeDiffSeconds > 1 ? 's' : ''}`;
      } else {
        return '';
      }
    } catch (error) {
      console.error('Error calculating time difference:', error);
      return '';
    }
  }

  // ---------------------------------------------------------------------------
  // ControlX activity rail
  //
  // Snapshot first so the rail paints immediately, stream second so it stays
  // live. All the API/SSE work lives in ControlxActivityService; what follows is
  // only this page's state and the states the rail can be in.
  // ---------------------------------------------------------------------------

  /** Runs once per page, and only once the order id is actually known. */
  private initControlxActivity(): void {
    if (this.controlxStarted || !this.showControlxPanel || !this.orderId) return;
    // A build with no ControlX origin gets the untouched placeholder, not an error.
    if (!this.controlxActivity.isConfigured) return;

    this.controlxStarted = true;
    this.loadControlxSnapshot(true);
  }

  /**
   * Pulls the REST snapshot. `connectStream` is true for the first load and
   * false for the top-up after a reconnect, where a stream already exists.
   */
  private loadControlxSnapshot(connectStream: boolean): void {
    if (connectStream) this.controlxStatus = 'loading';

    this.controlxActivity
      // Asks for as much history as the rail can hold, rather than the spec's
      // default 50. The feed is newest-first across every prefix at once, so a
      // burst of ORDER rows can push an older AGENT/SLA/SUPERVISOR entry past a
      // small limit and make whole feeds look absent. No `prefix` is sent —
      // leaving it unset is what asks for all of them.
      .getActivity({ orderId: this.orderId, limit: this.CONTROLX_MAX_ENTRIES })
      .pipe(takeUntil(this.controlxStop$))
      .subscribe({
        next: snapshot => {
          this.controlxWatching = snapshot.watching;
          this.mergeControlxEntries(snapshot.entries);
          this.controlxStatus = 'ready';
          this.controlxErrorKind = null;
          if (connectStream) this.connectControlxStream();
        },
        error: (error: ControlxError) => {
          const kind = error?.kind ?? 'unknown';
          this.controlxErrorKind = kind;
          // Rows already on screen stay on screen; only a rail with nothing in it
          // switches to the error caption.
          this.controlxStatus = this.controlxActivities.length ? 'ready' : 'error';
          // An expired token or a missing addon fails the stream the same way it
          // failed this call, so opening one would only start a retry loop.
          if (connectStream && !isControlxTerminalError(kind)) this.connectControlxStream();
        }
      });
  }

  /** Opens the live stream. Guarded so the page can never hold two connections. */
  private connectControlxStream(): void {
    if (this.controlxStreamSub && !this.controlxStreamSub.closed) return;

    this.controlxStream = 'connecting';
    this.controlxStreamSub = this.controlxActivity
      .streamActivity({ orderId: this.orderId })
      .pipe(takeUntil(this.controlxStop$))
      .subscribe({
        next: event => this.onControlxStreamEvent(event),
        error: (error: ControlxError) => {
          this.controlxStreamSub = undefined;
          this.controlxStream = 'offline';
          this.controlxErrorKind = error?.kind ?? 'network';
          if (!this.controlxActivities.length) this.controlxStatus = 'error';
        },
        complete: () => {
          this.controlxStreamSub = undefined;
          this.controlxStream = 'offline';
        }
      });
  }

  private onControlxStreamEvent(event: ControlxStreamEvent): void {
    switch (event.kind) {
      case 'open':
        this.controlxStream = 'live';
        this.controlxErrorKind = null;
        // EventSource replays from Last-Event-ID on its own, but that replay is
        // capped and the server only retains so much history — after a long
        // outage the snapshot is the only thing that closes the gap.
        if (event.reconnected) this.loadControlxSnapshot(false);
        break;

      case 'reconnecting':
        this.controlxStream = 'reconnecting';
        break;

      case 'activity':
        this.mergeControlxEntries([event.entry], true);
        this.controlxStatus = 'ready';
        this.controlxErrorKind = null;
        break;

      case 'action':
        this.onControlxAction(event.action, event.payload);
        break;
    }
  }

  /**
   * `re-assign` / `Cancel` fire when ControlX acts on the order by itself, with
   * no human confirmation pending — so the page is looking at an order that has
   * already changed underneath it.
   */
  private onControlxAction(action: 'reassign' | 'cancel', payload: any): void {
    const eventOrderId = payload?.order_id;
    // The stream is filtered server-side, but a frame for another order must
    // never be allowed to refresh or annotate this one.
    if (eventOrderId && String(eventOrderId) !== String(this.orderId)) return;

    const reason = typeof payload?.reason === 'string' ? payload.reason.trim() : '';
    const label = action === 'reassign'
      ? 'ControlX re-assigned this order'
      : 'ControlX cancelled this order';
    this.toaster.info(reason ? `${label} — ${reason}` : label);

    // Pull the order now instead of waiting out the rest of the 10s poll.
    if (this.orderId) this.getOrderDetails();
  }

  /**
   * Folds new entries in, deduping strictly on `activity.id`.
   *
   * Re-sorted rather than prepended: replay and backfill can deliver rows out of
   * order, and the rail is defined as newest-first.
   */
  private mergeControlxEntries(entries: ControlxActivity[], fresh: boolean = false): void {
    let changed = false;

    for (const entry of entries || []) {
      const id = controlxEntryId(entry);
      if (!id || this.controlxEntries.has(id)) continue;
      this.controlxEntries.set(id, entry);
      // Only rows that actually arrived on the stream announce themselves. The
      // snapshot's rows are history, however recently the page was opened.
      if (fresh) this.markControlxRowFresh(id);
      changed = true;
    }
    if (!changed) return;

    const sorted = Array.from(this.controlxEntries.values())
      .sort(compareControlxEntriesDesc)
      .slice(0, this.CONTROLX_MAX_ENTRIES);

    // Trim the dedupe map to match, or it keeps growing after the list stops.
    if (sorted.length < this.controlxEntries.size) {
      this.controlxEntries = new Map(sorted.map(entry => [controlxEntryId(entry), entry]));
    }

    this.controlxActivities = this.toControlxViews(sorted);
  }

  /**
   * Recounts the tabs and re-slices the visible rows.
   *
   * Done on assignment rather than in a getter because the list is bound in a
   * hot change-detection path — the rail re-renders on every stream frame, map
   * tick and timer — and filtering 50 rows per check would be work repeated
   * for nothing. Called only from the `controlxActivities` setter.
   */
  private recomputeControlxTabs(): void {
    const rows = this._controlxActivities;
    let decisions = 0;
    let contacts = 0;
    for (const row of rows) {
      if (row.group === 'decision') decisions++;
      if (row.isContact) contacts++;
    }

    this.controlxTabCounts = {
      all: rows.length,
      decisions,
      // Every row is exactly one of the two, so this needs no second pass.
      actions: rows.length - decisions,
      contacts
    };

    // The tab the reader chose is left alone even when it empties: a stream
    // frame silently yanking them back to All reads as the filter breaking.
    // The empty case renders a caption instead — see controlxTabEmptyLabel.
    this.controlxVisibleActivities = this.filterControlxRows(this.controlxTab);
  }

  /** Lowercased label of the active tab, for the "nothing here" caption. */
  get controlxTabEmptyLabel(): string {
    return this.controlxTabs.find(tab => tab.key === this.controlxTab)?.label.toLowerCase() ?? '';
  }

  private filterControlxRows(tab: ControlxTabKey): ControlxActivityView[] {
    switch (tab) {
      case 'decisions': return this._controlxActivities.filter(row => row.group === 'decision');
      case 'actions': return this._controlxActivities.filter(row => row.group === 'action');
      case 'contacts': return this._controlxActivities.filter(row => row.isContact);
      default: return this._controlxActivities;
    }
  }

  setControlxTab(tab: ControlxTabKey): void {
    if (this.controlxTab === tab) return;
    this.controlxTab = tab;
    this.controlxVisibleActivities = this.filterControlxRows(tab);
  }

  /** Maps entries to views, stamping the arrival flag on whatever is still fresh. */
  private toControlxViews(entries: ControlxActivity[]): ControlxActivityView[] {
    return entries.map(entry => {
      const view = toControlxActivityView(entry);
      return this.controlxFreshIds.has(view.id) ? { ...view, isNew: true } : view;
    });
  }

  /**
   * Flags a row as just-arrived and schedules it back to normal.
   *
   * The re-map on expiry produces new view objects, but `@for` tracks by
   * `activity.id`, so Angular keeps the existing DOM and the row simply loses
   * the class — it does not replay its entrance.
   */
  private markControlxRowFresh(id: string): void {
    clearTimeout(this.controlxFreshTimers.get(id));
    this.controlxFreshIds.add(id);

    this.controlxFreshTimers.set(id, setTimeout(() => {
      this.controlxFreshIds.delete(id);
      this.controlxFreshTimers.delete(id);
      this.controlxActivities = this.toControlxViews(
        Array.from(this.controlxEntries.values())
          .sort(compareControlxEntriesDesc)
          .slice(0, this.CONTROLX_MAX_ENTRIES)
      );
    }, this.CONTROLX_FRESH_MS));
  }

  /**
   * What the placeholder says when there are no rows.
   *
   * An order that is on track has no activity by design, so an empty rail must
   * report that ControlX is watching — never that nothing is monitoring it.
   */
  get controlxEmptyCaption(): string {
    if (this.controlxStatus === 'loading') return 'Loading activities…';

    switch (this.controlxErrorKind) {
      case 'unauthorized': return 'Session expired — sign in again';
      case 'forbidden': return 'ControlX is not enabled for this account';
      case 'not-found': return 'No ControlX visibility for this order';
      case 'network': return 'ControlX is unreachable right now';
      case 'unknown': return 'Activities are unavailable right now';
    }

    return formatControlxWatching(this.controlxWatching) || 'Activities';
  }

  /**
   * Statuses after which nothing more can happen to the order.
   *
   * Deliberately the same three the page already uses to stop `refreshInterval`
   * in ngOnInit — if the poller considers an order finished, the rail must not
   * still be claiming it is live.
   */
  private readonly ORDER_TERMINAL_STATUS_IDS: number[] = [
    constant.OrderStatusId.delivered,
    constant.OrderStatusId.cancelled,
    constant.OrderStatusId.RTODelivered
  ];

  /** Is the order still running? Drives the Live pill and the globe's spin. */
  get isOrderLive(): boolean {
    const statusId = Number(this.orderData?.order_status_id);
    if (!statusId) return false;
    return !this.ORDER_TERMINAL_STATUS_IDS.includes(statusId);
  }

  /** The order's status name, shown in place of Live once it is finished. */
  get orderStatusLabel(): string {
    const statusId = Number(this.orderData?.order_status_id);
    if (!statusId) return '';
    // Same lookup the rest of the page uses, quirk included, so the wording
    // cannot drift from the timeline and the 3PL card.
    return this.constant.OrderStatusName[statusId === 8 ? 23 : statusId] || '';
  }

  /**
   * What the Live pill says.
   *
   * A badge reading "Live" while the stream is down would be a lie, and this is
   * the one element on the page whose whole job is to say whether the feed is
   * current — so it follows the connection, not just the order status.
   */
  get controlxLiveLabel(): string {
    switch (this.controlxStream) {
      case 'reconnecting': return 'Thinking';
      case 'offline': return 'Offline';
      default: return 'Live';
    }
  }

  /** Live-connection state, as a tooltip on the rail heading. */
  get controlxStreamLabel(): string {
    switch (this.controlxStream) {
      case 'connecting': return 'Connecting to ControlX…';
      case 'live': return 'Live — connected to ControlX';
      case 'reconnecting': return 'Reconnecting to ControlX…';
      case 'offline': return 'Disconnected — showing the last activity received';
      default: return 'ControlX activities';
    }
  }

  ngOnDestroy() {
    // Ends both the snapshot subscription and the stream; the stream's teardown
    // closes the EventSource, so nothing outlives the page.
    this.controlxStop$.next();
    this.controlxStop$.complete();
    this.controlxStreamSub?.unsubscribe();
    this.controlxStreamSub = undefined;
    this.controlxEntries.clear();
    this.controlxActivities = [];
    this.controlxFreshTimers.forEach(timer => clearTimeout(timer));
    this.controlxFreshTimers.clear();
    this.controlxFreshIds.clear();

    this.disposeMapTheme?.();
    this.disposeMapTheme = undefined;
    // Disconnect before map.remove(): the observer holds the map's own
    // container, so leaving it live would keep the removed map reachable.
    this.disposeMapResize?.();
    this.disposeMapResize = undefined;
    // Leaving the map expanded and navigating away would strand the scroll lock
    // on a page that no longer has anything covering it.
    if (this.isMapExpanded) {
      this.setPageScrollLock(false);
      this.isMapExpanded = false;
    }
    // Same reasoning for the proof viewer: navigating away with it open would
    // leave the lock on a page that no longer has anything covering it.
    if (this.proofViewer) {
      this.setPageScrollLock(false);
      this.proofViewer = null;
    }
    // The 3PL sheet takes no scroll lock (see open3plSheet), just its own flag.
    clearTimeout(this.threePlSheetCloseTimer);
    this.show3plSheet = false;
    this.is3plSheetClosing = false;
    // Same reasoning as the proof viewer above: the ControlX sheet does
    // take the lock, and navigating away with it open would strand it.
    if (this.showControlxSheet) {
      this.setPageScrollLock(false);
      this.showControlxSheet = false;
    }
    this.collapsedView = null;
    // Both can still be pending if the dialog is dismissed while the loader
    // is up, and they would set state on a destroyed view.
    clearTimeout(this.orderLoaderHoldTimer);
    clearTimeout(this.orderLoaderExitTimer);
    clearTimeout(this.statusLoaderHoldTimer);
    clearTimeout(this.statusLoaderExitTimer);
    clearTimeout(this.statusFlashTimer);
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    clearTimeout(this.statusFlashTimer);
    this.stopStatusTypewriter();
    this.pauseRiderPlayback();
    this.cancelPlayCountdown();
    if (this.map) {
      this.map.remove();
      // map.remove() takes its layers down with it, so this reference is dead
      // from here on -- dropping it keeps a stale group from being reused if
      // the component is ever re-entered without a fresh construction.
      this.orderMarkerLayer = null;
      this.hasFitOrderMarkers = false;
    }
  }

  latLngFixed(num: any, digits: number): string {
    if (num === null || num === undefined || num === '' || isNaN(Number(num))) {
      return 'N/A';
    }
    const fixed = Number(num).toFixed(digits);
    return fixed;
  }
  getLocationDetail(detail: any) {
    if (!this.map) return;

    const lat = detail.lat;
    const lng = detail.long;

    if (lat && lng) {
      // Pan + Zoom to location
      this.map.setView([lat, lng], 100, {
        animate: true,
      });
    }
  }
  getNotificationList() {
    var url = constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.NotificationList;
    this.http.postData(url, { order_id: this.orderId }).subscribe((response: any) => {
      if (response.status) {
        this.notificationList = response?.data;
        // One row per notified staff member, so the staff is the identity —
        // count_notify is deliberately out of the key, since a rising count
        // should update the row rather than replace it.
        this.stampRowKeys(this.notificationList, row =>
          `${row?.DeliveryStaff?.user_id ?? row?.DeliveryStaff?.full_name ?? ''}`);
      } else {
        this.notificationList = [];
      }
    });

  }
  reassignOrder(type: any) {
    if (type == 'open') {
      this.reassignModalRef = this.modalService.open(this.modalWrning, { centered: true, size: "md" });
    } else {
      this.loder.show()
      var url = constant.Service.MainMaster.BaseUrl + constant.Service.MainMaster.Order.OrderReassign;
      this.http.postData(url, { order_id: this.orderId, order_from_user_id: this.orderData.order_from_user_id }).subscribe((response: any) => {
        this.loder.hide()
        this.reassignModalRef?.close();
        if (response.status) {
          this.getOrderDetails()
          this.toaster.success(response.message);
        } else {
          this.toaster.error(response.message);
        }
      });
    }

  }

  DownloadImage(item?: any, name?: any) {
    var laststring = item.substr(item.lastIndexOf('/') + 1);
    if (laststring != "img?url=null") {
      saveAs(item, name);
    } else {
      this.toaster.error("No Image")
    }
  }
  openItemPop() {
    let type = this.reqfor == 'history' ? this.reqfor : 'live'
    const modalRef = this.modalService.open(ElefantOrderDetailsComponent, { scrollable: true, windowClass: 'myCustomModalClass ad-modal-overflow-visible', size: 'xl' });
    modalRef.componentInstance.orderData = { orderType: type, orderId: this.orderId };
  }

  /** Placeholder used whenever an ordering partner's logo is missing. */
  private static readonly defaultStoreLogo = 'assets/images/stores/default.png';

  /**
   * Logo for the ordering partner shown beside `User.full_name`.
   *
   * The detail payload carries no logo url for the ordering partner -- only the
   * name -- so the filename is guessed from that name exactly the way the Live
   * Orders list does it (lowercased, spaces stripped, under assets/images/stores).
   * Guessing is what makes the two screens agree: a store shows the same bundled
   * logo in the list and on this page, with no second source of truth to keep in
   * sync. A store with no file shipped under that name simply misses, and
   * `onPartnerLogoError()` swaps in the placeholder.
   */
  get orderingPartnerLogo(): string {
    const name = this.orderData?.User?.full_name;
    if (!name) { return OrderDetailViewComponent.defaultStoreLogo; }
    return 'assets/images/stores/' + String(name).toLowerCase().split(' ').join('') + '.png';
  }

  /**
   * Covers a missing logo with the placeholder.
   *
   * Guarded against the placeholder itself 404ing: reassigning the same src would
   * start the load again and re-enter this handler, so bail instead of looping.
   */
  onPartnerLogoError(event: Event) {
    const img = event.target as HTMLImageElement | null;
    if (!img) { return; }
    if (img.getAttribute('src') === OrderDetailViewComponent.defaultStoreLogo) { return; }
    img.src = OrderDetailViewComponent.defaultStoreLogo;
  }
}
